webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function getParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search.substr(1).split("&").forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
}

exports.default = getParameter;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

exports.default = debounce;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getParameter = __webpack_require__(4);

var _getParameter2 = _interopRequireDefault(_getParameter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UTM() {
    this.parameters = ['source', 'medium', 'campaign', 'term', 'content'];
}

UTM.prototype.storeData = function () {
    var utm = {};
    var one_utm_param_found = false;
    var key = void 0;
    var value = void 0;

    for (var i = 0; i < this.parameters.length; i++) {
        key = this.parameters[i];
        value = (0, _getParameter2.default)('utm_' + key);
        if (value) {
            utm[key] = value;
            one_utm_param_found = true;
        }
    }

    if (one_utm_param_found) {
        localStorage.setItem('gp_utm', JSON.stringify(utm));
    }
};

UTM.prototype.getData = function () {
    var utm = localStorage.getItem('gp_utm');
    if (utm) {
        return JSON.parse(utm);
    }
    return false;
};

exports.default = UTM;

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
function Tabs() {
    var autoPlayInterval = null;

    this.setAutoPlayInterval = function (value) {
        autoPlayInterval = value;
    };
    this.getAutoPlayInterval = function () {
        return autoPlayInterval;
    };

    this.tabsElements = document.querySelectorAll('.tab');
    this.contentsElements = document.querySelectorAll('.tab__content');
    this.init();
}

Tabs.prototype.init = function () {

    var triggers = document.querySelectorAll('.tab__trigger'),
        tab = null,
        trigger = null,
        content = null,
        target = null;

    if (this.tabsElements !== null) {
        var that = this;
        for (var i = 0; i < this.tabsElements.length; i++) {

            tab = this.tabsElements[i];

            tab.addEventListener('click', function (event) {
                var targetFound = that.toogleTab(this, this.dataset.target, true);
            });
        }

        if (triggers !== null) {

            for (var i = 0; i < triggers.length; i++) {

                trigger = triggers[i];

                trigger.addEventListener('click', function (event) {

                    event.preventDefault();
                    var targetFound = false;
                    target = this.dataset.target;

                    // toggle tab class
                    for (var j = 0; j < this.tabsElements.length; j++) {
                        tab = this.tabsElements[j];
                        if (tab.dataset.target == target) {
                            tab.classList.add('active');
                        } else {
                            tab.classList.remove('active');
                        }
                    }

                    // toggle content class
                    for (var k = 0; k < contents.length; k++) {
                        content = contents[k];
                        if (content.classList.contains(target)) {
                            content.classList.add('show');
                            targetFound = true;
                        } else {
                            content.classList.remove('show');
                        }
                    }

                    if (targetFound) {
                        jQuery('html, body').animate({
                            scrollTop: jQuery('.tab__container').offset().top - 10
                        }, 500);
                    }
                });
            }
        }
    }
};

Tabs.prototype.toogleTab = function (element, target) {
    var disableAutoPlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var content = null,
        targetFound = false;
    if (!element.classList.contains('active')) {

        element.classList.add('active');

        // toggle tab class
        for (var j = 0; j < this.tabsElements.length; j++) {
            if (this.tabsElements[j] != element) {
                this.tabsElements[j].classList.remove('active');
            }
        }

        // toggle content class
        for (var k = 0; k < this.contentsElements.length; k++) {
            content = this.contentsElements[k];
            if (content.classList.contains(target)) {
                content.classList.add('show');
                targetFound = true;
            } else {
                content.classList.remove('show');
            }
        }
    }

    if (disableAutoPlay && this.getAutoPlayInterval() !== null) {
        clearInterval(this.getAutoPlayInterval());
        this.setAutoPlayInterval(null);
    }

    return targetFound;
};

Tabs.prototype.autoPlay = function (selector) {
    var container = document.getElementsByClassName(selector);
    if (container[0]) {
        var children = container[0].children;
        var iterator = 0;
        var maxIteration = children.length;
        var that = this;
        if (maxIteration > 0) {
            that.setAutoPlayInterval(setInterval(function () {
                if (iterator < maxIteration - 1) iterator++;else iterator = 0;

                that.toogleTab(children[iterator], children[iterator].dataset.target);
            }, 5000));
        }
    }
};

exports.default = Tabs;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function extendDefaults(src, prop) {
    var property;

    for (property in prop) {
        if (prop.hasOwnProperty(property)) {
            src[property] = prop[property];
        }
    }
}

function getWindowScrollPosition() {
    var doc = document.documentElement;
    var leftPos = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    var topPos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    return {
        left: leftPos,
        top: topPos
    };
}

function overlay(opt) {
    var that = this;

    that.options = {
        classes: {
            closeButton: '.overlay__close'
        },
        events: {
            init: '',
            beforeOpen: '',
            afterOpen: '',
            beforeClose: '',
            afterClose: ''
        }
    };

    that.windowScrollLock = false;
    that.windowScrollPosition;

    if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) === 'object') {
        extendDefaults(that.options, opt);
    }

    that.elements = {};

    if (typeof that.options.trigger === "string") {
        that.elements.trigger = document.querySelector(that.options.trigger);
    } else {
        that.elements.trigger = that.options.trigger;
    }

    if (that.elements.trigger !== null) {
        if (that.elements.trigger.length > 0) {
            for (var k = 0; k < that.elements.trigger.length; k++) {
                that.elements.trigger[k].addEventListener('click', that.open.bind(that), false);
                if (that.elements.trigger[k].getAttribute('data-target') !== null) {
                    that.elements.overlay = document.querySelector(that.elements.trigger[k].getAttribute('data-target'));
                    that.elements.inner = that.elements.overlay.children;
                }
            }
        }
        // else {
        //     console.log(that.elements.trigger);
        //     that.elements.trigger.addEventListener('click', that.open.bind(that), false);
        //     if (that.elements.trigger.getAttribute('data-target') !== null) {
        //         that.elements.overlay = document.querySelector(that.elements.trigger.getAttribute('data-target'));
        //         that.elements.inner = that.elements.overlay.children;
        //     }
        // };
    } else {
        return;
    }

    that.elements.closeButton = that.elements.overlay.querySelectorAll(that.options.classes.closeButton);

    if (that.elements.closeButton !== null) {
        for (var i = 0; i < that.elements.closeButton.length; i++) {
            that.elements.closeButton[i].addEventListener('click', that.close.bind(that), false);
        }
    }

    if (typeof that.options.events.init === 'function') {
        // Init Call
        that.options.events.init.call();
    }

    window.addEventListener('scroll', function () {
        if (that.windowScrollLock == true) {
            window.scrollTo(that.windowScrollPosition.left, that.windowScrollPosition.top);
        }
    });
}

overlay.prototype.open = function (e) {
    if (typeof e !== "undefined") {
        e.preventDefault();
    }

    this.windowScrollPosition = getWindowScrollPosition();

    if (typeof this.options.events.beforeOpen === 'function') {
        // Before Open Call
        this.options.events.beforeOpen.call(this.elements);
    }

    this.elements.overlay.classList.add('is-visible');
    this.elements.inner[0].addEventListener('click', function (e) {
        e.stopPropagation();
    });
    this.elements.overlay.addEventListener('click', this.close.bind(this), false);

    if (typeof this.options.events.afterOpen === 'function') {
        // After Open Call
        this.options.events.afterOpen.call();
    }

    this.windowScrollLock = true;
};

overlay.prototype.close = function (e) {
    if (typeof e !== "undefined") {
        e.preventDefault();
    }

    if (typeof this.options.events.beforeClose === 'function') {
        // Before Close Call
        this.options.events.beforeClose.call();
    }

    this.elements.overlay.classList.remove('is-visible');
    this.elements.overlay.removeEventListener('click', this.close.bind(this));

    if (typeof this.options.events.afterClose === 'function') {
        // After Close Call
        this.options.events.afterClose.call();
    }

    this.windowScrollLock = false;
};

exports.default = overlay;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function Toggle(switcher, target, toggle_switcher_class, toggle_target_class) {
    var target_is_child = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var target_is_sibling = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;


    this.switchElSelector = switcher;
    this.targetElSelector = target;

    this.switchEl = document.querySelectorAll(switcher);
    this.targetEl;

    this.toggleSwitchElClass = toggle_switcher_class;
    this.toggleTargetElClass = toggle_target_class;

    if (this.targetElSelector) {
        if (!target_is_child && !target_is_sibling) {
            this.targetEl = document.querySelectorAll(target);
        }
    }

    if (this.switchEl) {
        this.init(target_is_child, target_is_sibling);
    }
}

Toggle.prototype.init = function (target_is_child, target_is_sibling) {

    var that = this;

    var switchEl, targetEl, childTargets, siblingTargets;

    for (var i = 0; i < this.switchEl.length; i++) {

        switchEl = this.switchEl[i];

        switchEl.addEventListener('click', function (event) {

            if (target_is_child && event.target == this || !target_is_child) {
                this.classList.toggle(that.toggleSwitchElClass);
            }

            if (that.targetElSelector) {
                if (that.targetEl && that.targetEl.length > 0) {
                    for (var k = 0; k < that.targetEl.length; k++) {
                        targetEl = that.targetEl[k];
                        targetEl.classList.toggle(that.toggleTargetElClass);
                    }
                } else {
                    if (target_is_child) {

                        childTargets = this.children;

                        if (event.target == this) {
                            for (var j = 0; j < childTargets.length; j++) {
                                targetEl = childTargets[j];
                                if (targetEl.matches(that.targetElSelector)) {
                                    targetEl.classList.toggle(that.toggleTargetElClass);
                                }
                            }
                        }
                    } else if (target_is_sibling) {

                        siblingTargets = this.parentNode.querySelectorAll(that.targetElSelector);
                        for (var j = 0; j < siblingTargets.length; j++) {
                            targetEl = siblingTargets[j];
                            targetEl.classList.toggle(that.toggleTargetElClass);
                        }
                    }
                }
            }
        });
    }
};

exports.default = Toggle;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function transitionend() {
    function transitionEndEventName() {
        var i,
            undefined,
            el = document.createElement('div'),
            transitions = {
            'transition': 'transitionend',
            'OTransition': 'otransitionend', // oTransitionEnd in very old Opera
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };

        for (i in transitions) {
            if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
                return transitions[i];
            }
        }

        //TODO: throw 'TransitionEnd event is not supported in this browser';
    }
}

exports.default = transitionend;

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

var _Router = __webpack_require__(50);

var _Router2 = _interopRequireDefault(_Router);

var _common = __webpack_require__(36);

var _common2 = _interopRequireDefault(_common);

var _home = __webpack_require__(37);

var _home2 = _interopRequireDefault(_home);

var _singleProduct = __webpack_require__(41);

var _singleProduct2 = _interopRequireDefault(_singleProduct);

var _pageTemplateConsultation = __webpack_require__(38);

var _pageTemplateConsultation2 = _interopRequireDefault(_pageTemplateConsultation);

var _postTypeArchiveProduct = __webpack_require__(40);

var _postTypeArchiveProduct2 = _interopRequireDefault(_postTypeArchiveProduct);

var _pageTemplateFaqs = __webpack_require__(39);

var _pageTemplateFaqs2 = _interopRequireDefault(_pageTemplateFaqs);

var _woocommerceCart = __webpack_require__(48);

var _woocommerceCart2 = _interopRequireDefault(_woocommerceCart);

var _woocommerceCheckout = __webpack_require__(49);

var _woocommerceCheckout2 = _interopRequireDefault(_woocommerceCheckout);

var _woocommerceAccountViewConsultation = __webpack_require__(45);

var _woocommerceAccountViewConsultation2 = _interopRequireDefault(_woocommerceAccountViewConsultation);

var _woocommerceAccountViewSubscription = __webpack_require__(46);

var _woocommerceAccountViewSubscription2 = _interopRequireDefault(_woocommerceAccountViewSubscription);

var _woocommerceAccountDashboard = __webpack_require__(42);

var _woocommerceAccountDashboard2 = _interopRequireDefault(_woocommerceAccountDashboard);

var _woocommerceAccountEditAccount = __webpack_require__(43);

var _woocommerceAccountEditAccount2 = _interopRequireDefault(_woocommerceAccountEditAccount);

var _woocommerceAccountLostPassword = __webpack_require__(44);

var _woocommerceAccountLostPassword2 = _interopRequireDefault(_woocommerceAccountLostPassword);

var _woocommerceAccount = __webpack_require__(47);

var _woocommerceAccount2 = _interopRequireDefault(_woocommerceAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var singleConsultationConfig = _pageTemplateConsultation2.default; // import "jquery";


var pageTemplatePageLanding = _home2.default;
var pageTemplateVitamins = _postTypeArchiveProduct2.default;
var pageTemplateBundles = _postTypeArchiveProduct2.default;

var routes = new _Router2.default({
    common: _common2.default,
    home: _home2.default,
    pageTemplateConsultation: _pageTemplateConsultation2.default,
    singleConsultationConfig: singleConsultationConfig,
    postTypeArchiveProduct: _postTypeArchiveProduct2.default,
    pageTemplateFaqs: _pageTemplateFaqs2.default,
    pageTemplateVitamins: pageTemplateVitamins,
    pageTemplateBundles: pageTemplateBundles,
    woocommerceCart: _woocommerceCart2.default,
    woocommerceCheckout: _woocommerceCheckout2.default,
    singleProduct: _singleProduct2.default,
    woocommerceAccountViewConsultation: _woocommerceAccountViewConsultation2.default,
    woocommerceAccountViewSubscription: _woocommerceAccountViewSubscription2.default,
    woocommerceAccountDashboard: _woocommerceAccountDashboard2.default,
    woocommerceAccountEditAccount: _woocommerceAccountEditAccount2.default,
    woocommerceAccountLostPassword: _woocommerceAccountLostPassword2.default,
    woocommerceAccount: _woocommerceAccount2.default,
    pageTemplatePageLanding: pageTemplatePageLanding
});

function ready(func) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
        func();
    } else {
        document.addEventListener("DOMContentLoaded", func);
    }
}

ready(function () {
    routes.loadEvents();

    var accountFirstName = jQuery('#account_first_name');
    var accountLastName = jQuery('#account_last_name');
    var surveyInput = jQuery('#surveyContainer.form-control');

    // First letter uppercase
    var elementFirstUpper = function elementFirstUpper(el) {
        el.keyup(function () {
            var str = el.val().toLowerCase();

            var spart = str.split(" ");
            for (var i = 0; i < spart.length; i++) {
                var j = spart[i].charAt(0).toUpperCase();
                spart[i] = j + spart[i].substr(1);
            }
            el.val(spart.join(" "));
        });
    };

    elementFirstUpper(accountFirstName);
    elementFirstUpper(accountLastName);
    elementFirstUpper(surveyInput);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
function CalendarReminder() {
    this.button = document.querySelector(".button--reminder");
    if (this.button) {
        this.button.addEventListener("click", downloadReminder);
    }
    return;
}

function isSafariIOS() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    return iOSSafari;
}

function isIOS() {
    return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    navigator.userAgent.includes("Mac") && "ontouchend" in document;
}

function pad(number) {
    if (number < 10) {
        return "0" + number;
    }
    return number;
}

function formatDateForIcs(d) {
    var str = d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + "T" + pad(d.getHours()) + pad(d.getMinutes()) + "00";
    return str;
}

function downloadReminder() {
    var hostname = location.hostname + ":" + location.port;
    var input = jQuery("#reminder-input");
    var input_message = document.getElementById("reminder-title-input-message");
    var title = jQuery("#reminder-title").val();
    if (!title) {
        title = "Take Everly Wellness Vitamins";
    }
    var time = jQuery("#reminder-time").val();
    var start = new Date(time);
    var end = new Date(start.getTime() + 600000);
    var now = new Date();
    var filename = "Everly-Wellness-Vitamin-Reminder";

    if (input && input_message && title.length < 1) {
        input.addClass("is-error");
        input_message.innerHTML = "Please enter a name for your reminder";
        return;
    } else if (input && input_message) {
        input.removeClass("is-error");
        input_message.innerHTML = "";
    }

    if (isSafariIOS()) {
        var iCalendarData = ["BEGIN:VCALENDAR", "CALSCALE:GREGORIAN", "PRODID:-//Everly Wellness//Reminder//EN", "VERSION:2.0", "BEGIN:VEVENT", "RRULE:FREQ=DAILY;INTERVAL=1",
        // 'DTSTAMP:20200625T183939',
        // 'DTSTART:20200628T070000',
        // 'DTEND:20200628T071010',
        "DTSTAMP:" + formatDateForIcs(now), "DTSTART:" + formatDateForIcs(start), "DTEND:" + formatDateForIcs(end), "SUMMARY:" + title, "UID:4088E990AD89VW3DBB484909", "END:VEVENT", "END:VCALENDAR"].join("\n");
        var blob = new Blob([iCalendarData], {
            type: "text/calendar"
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename + ".ics";
        link.click();
    } else if (isIOS()) {
        // Chrome iOS
        var icsLink = document.createElement("a");
        icsLink.style.display = "none";
        var webcal_title = encodeURI(title);
        var webcal_start = encodeURI(start.getTime()); // 00:00:00
        var webcal_url = "webcal://" + hostname + "/?calreminder=" + webcal_title + "&start=" + webcal_start;
        // console.log("webcal_url", webcal_url);
        icsLink.href = webcal_url;
        document.body.appendChild(icsLink);
        icsLink.click();
        document.body.removeChild(icsLink);
    } else {
        var cal = ics();
        cal.addEvent(title, "", "", start, end, {
            rrule: "RRULE:FREQ=DAILY;INTERVAL=1"
        });
        cal.download(filename);
    }

    if (typeof dataLayer !== "undefined") {
        dataLayer.push({
            event: "custom-event",
            customEventCategory: "reminder",
            customEventAction: "click-add-reminder",
            customEventLabel: null,
            customEventValue: null
        });
    }

    if (typeof _cio !== "undefined") {
        _cio.track("vitamin_reminder_clicked");
    }
}

exports.default = CalendarReminder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _debounce = __webpack_require__(5);

var _debounce2 = _interopRequireDefault(_debounce);

var _transitionend = __webpack_require__(16);

var _transitionend2 = _interopRequireDefault(_transitionend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CheckoutNav() {
    this.checkout_form = jQuery('form.checkout');

    this.validate_customer_details = document.getElementById('validate-customer-details');
    this.back_customer_details = document.querySelector('.back-customer-details');
    this.steps_container = document.querySelector('.checkout__steps-inner');

    this.customer_details_el = document.querySelector('.checkout__step--customer');
    this.payment_el = document.querySelector('.checkout__step--payment');
    this.place_order_btn = document.getElementById('place_order');

    var that = this;
    that.init();
}

CheckoutNav.prototype.init = function () {
    var that = this;

    var billingFirstName = jQuery('#billing_first_name');
    var billingLastName = jQuery('#billing_last_name');
    var shippingFirstName = jQuery('#shipping_first_name');
    var shippingLastName = jQuery('#shipping_last_name');

    // First letter uppercase
    var elementFirstUpper = function elementFirstUpper(el) {
        el.keyup(function () {
            var str = el.val().toLowerCase();

            var spart = str.split(" ");
            for (var i = 0; i < spart.length; i++) {
                var j = spart[i].charAt(0).toUpperCase();
                spart[i] = j + spart[i].substr(1);
            }
            el.val(spart.join(" "));
        });
    };

    elementFirstUpper(billingFirstName);
    elementFirstUpper(billingLastName);
    elementFirstUpper(shippingFirstName);
    elementFirstUpper(shippingLastName);

    jQuery('form.checkout').submit(function (event) {
        event.preventDefault();
        that.checkPasswordBeforePlaceOrder(event);
    });

    jQuery('#account_password').after("<span id='password_strength' class='woocommerce-password-strength'></span>");
    jQuery("#account_password").keyup(function (e) {
        window.checkPasswordStrength(jQuery(this), jQuery('#password_strength'), [], jQuery('#place_order'), true);
    });

    document.addEventListener('updated-checkout', function () {
        that.checkBillingShippingFields();
    });

    // if not mobile
    if (this.back_customer_details !== null && this.validate_customer_details !== null) {

        this.back_customer_details.addEventListener('click', function () {
            that.onBackClick();
        });

        this.validate_customer_details.addEventListener('click', function () {
            that.onNextClick();
        });

        // prevent tabbing to next step
        jQuery("form.checkout input").keydown(function (e) {

            that.ship_to_different_address = document.querySelector('#ship-to-different-address-checkbox');
            that.create_account = document.querySelector('div.create-account');

            if ((e.which || e.keyCode || e.charCode) == 9) {

                if (that.ship_to_different_address.checked) {
                    that.last_customer_input = jQuery('#shipping_postcode');
                } else {
                    that.last_customer_input = jQuery('#billing_email');
                    if (document.getElementById('billing_email_confirm')) {
                        that.last_customer_input = jQuery('#billing_email_confirm');
                    }
                    if (that.create_account && that.create_account.style.display != 'none') {
                        that.last_customer_input = jQuery('#account_password');
                    }
                }

                if (jQuery(this)[0] == that.last_customer_input[0]) {
                    e.preventDefault();
                }
            }
        });
    }
};

CheckoutNav.prototype.checkPasswordBeforePlaceOrder = function (event) {
    var errors = false;
    this.create_account = document.querySelector('div.create-account');

    if (this.create_account && this.create_account.style.display != 'none') {
        // if account fields showing
        this.password = document.getElementById('account_password').value;
        if (!window.password_meets_min_reqs(this.password) && window.new_password_strength < 2) {
            errors = true;
            jQuery('#account_password_field').addClass('woocommerce-invalid');
        }
    }

    if (errors) {
        event.preventDefault();
        jQuery('html, body').animate({
            scrollTop: jQuery(".woocommerce-invalid").offset().top - 100
        }, 500);
    }
};

CheckoutNav.prototype.validateField = function (field) {

    // there might be a better way of doing this, trigger woocommerce validation on input to verify class?

    var input = field.querySelector('input');

    if (input && input.value != "" && field.classList.contains('woocommerce-invalid')) {
        field.classList.remove('woocommerce-invalid');
    }

    if (input && input.value == "" || field.classList.contains('woocommerce-invalid')) {
        field.classList.add('woocommerce-invalid');
        return true;
    }

    return false;
};

CheckoutNav.prototype.checkBillingShippingFields = function () {

    // can change after page load
    this.required_billing_fields = document.querySelectorAll('.woocommerce-billing-fields .validate-required');

    this.ship_to_different_address = document.querySelector('#ship-to-different-address-checkbox');
    this.required_shipping_fields = document.querySelectorAll('.woocommerce-shipping-fields .validate-required');

    var that = this;
    var errors = false;

    for (var i = 0; i < this.required_billing_fields.length; i++) {
        var field = this.required_billing_fields[i];
        if (this.validateField(field)) {
            errors = true;
        }
    }

    if (this.ship_to_different_address.checked) {
        for (var i = 0; i < this.required_shipping_fields.length; i++) {
            var field = this.required_shipping_fields[i];
            if (this.validateField(field)) {
                errors = true;
            }
        }
    }

    return errors;
};

CheckoutNav.prototype.onNextClick = function () {

    this.create_account = document.querySelector('div.create-account');
    this.password = document.getElementById('account_password');
    if (this.password) this.password = this.password.value;

    this.billing_email_value = document.getElementById('billing_email').value;
    // get confirm value if field is there (ie. not logged in)
    if (document.getElementById('billing_email_confirm')) {
        this.billing_email_confirm_value = document.getElementById('billing_email_confirm').value;
    } else {
        this.billing_email_confirm_value = this.billing_email_value;
    }

    var that = this;
    var errors = this.checkBillingShippingFields();

    if (this.create_account && this.create_account.style.display != 'none') {
        // if account fields showing
        if (!window.password_meets_min_reqs(this.password) && window.new_password_strength < 2) {
            errors = true;
            jQuery('#account_password_field').addClass('woocommerce-invalid');
        }
    }

    if (this.billing_email_value != this.billing_email_confirm_value) {
        errors = true;
        document.getElementById('billing_email_confirm_field').classList.add('woocommerce-invalid');
    }

    if (errors) {
        jQuery('html, body').animate({
            scrollTop: jQuery(".woocommerce-invalid").offset().top - 100
        }, 500);
    }

    if (!errors) {

        that.validate_customer_details.classList.add('waiting');
        var post_data = jQuery('form.woocommerce-checkout').serializeArray();

        post_data = post_data.filter(this.checkIfFirstStepField);

        post_data.push({ name: 'do_not_complete', value: 1 });

        jQuery.ajax({
            type: "POST",
            url: "?wc-ajax=checkout",
            data: post_data
        }).done(function (response) {

            var responseType = typeof response === "undefined" ? "undefined" : _typeof(response);
            var newResponseType = false;

            if (responseType == 'object') {
                newResponseType = true;
            } else {
                response = JSON.parse(response);
            }

            console.log(response);
            console.log(responseType);

            that.validate_customer_details.classList.remove('waiting');

            if (response.status == "success") {

                that.steps_container.classList.add('show-payment');

                jQuery('.woocommerce-NoticeGroup-checkout').remove();

                jQuery('html, body').animate({
                    scrollTop: jQuery(".checkout__steps").offset().top - 100
                }, 500);
            } else {

                var html = "";
                html += "<div class='woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout'>";

                if (newResponseType) {
                    if (response.messages) {
                        html += response.messages;
                    }
                } else {
                    html += "<ul class='woocommerce-error' role='alert'>";
                    for (var i = 0; i < response.errors.length; i++) {
                        html += "<li>" + response.errors[i] + "</li>";
                    }
                    html += "</ul>";
                }

                html += "</div>";

                jQuery('form.woocommerce-checkout').prepend(html);

                jQuery('html, body').animate({
                    scrollTop: jQuery(".woocommerce-NoticeGroup-checkout").offset().top - 100
                }, 500);
            }
        });
    }
};

CheckoutNav.prototype.checkIfFirstStepField = function (field) {

    if (field.name == 'woocommerce-process-checkout-nonce' || field.name == '_wp_http_referer') {
        return true;
    }

    if (field.name.indexOf('billing_') !== -1 || field.name.indexOf('shipping_') !== -1) {
        return true;
    }

    return false;
};

CheckoutNav.prototype.onBackClick = function () {
    var that = this;
    // console.log('onbackclick');
    this.steps_container.classList.remove('show-payment');
    jQuery('html, body').animate({
        scrollTop: jQuery(".checkout__steps").offset().top - 100
    }, 500);
};

exports.default = CheckoutNav;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getParameter = __webpack_require__(4);

var _getParameter2 = _interopRequireDefault(_getParameter);

var _reports = __webpack_require__(26);

var _reports2 = _interopRequireDefault(_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components/consultation

exports.default = _reports2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _getParameter = __webpack_require__(4);

var _getParameter2 = _interopRequireDefault(_getParameter);

var _debounce = __webpack_require__(6);

var _debounce2 = _interopRequireDefault(_debounce);

var _overlay = __webpack_require__(14);

var _overlay2 = _interopRequireDefault(_overlay);

var _utmTracking = __webpack_require__(7);

var _utmTracking2 = _interopRequireDefault(_utmTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Consultation() {

  window.consultation_status = "rendering";
  window.confirmOverlay = new _overlay2.default({
    trigger: document.querySelectorAll('.overlay__button--overlay-confirm')
  });

  this.slideNextEvent = new CustomEvent("survey-slide-next");
  this.slidePrevEvent = new CustomEvent("survey-slide-prev");

  this.saveError = false;

  this.mode = "live";

  this.nonce = window.nonce;

  this.loadingEl = document.querySelector('.consultation__loading');

  this.pagesEl = document.querySelector('.consultation__pages');
  this.pagesElMover = this.pagesEl.querySelector('.mover');
  this.prevBtn = null;

  this.user_id = null;
  this.user_validated = false;

  this.last_rendered_question = null;

  this.new_password_strength = null;

  this.sent_data = {};
  this.send_data = {};
  this.data = {};

  this.truth_table = null;
  this.scores = null;
  this.reports = null;
  this.reports_truth_table = null;
  this.various_texts = null;

  this.truth_table_json = "../truth_table.json";
  this.scores_json = "../scores.json";
  this.reports_json = "../d_and_l_reports.json";
  this.reports_truth_table_json = "../reports_truthtable.json";
  this.various_texts_json = "../various_texts.json";

  // if (this.mode == "test") {
  //   this.truth_table_json = "../test_truth_table.json";
  //   this.scores_json = "../test_scores.json";
  // }

  this.cachedOtherGoalsThatWereCut = [];
  this.MaxCapsules = 4;

  var that = this;

  if (_typeof(window.SurveyJS) == 'object') {
    that.loadResources(window.SurveyJS);
  } else {
    document.addEventListener("survey-init", function () {
      that.loadResources(window.SurveyJS);
    });
  }

  document.addEventListener("survey-slide-next", function () {
    that.slideNext();
  });

  document.addEventListener("survey-slide-prev", function () {
    that.slidePrev();
  });

  var setChoicesHeightFunction = (0, _debounce2.default)(function () {
    that.setChoicesHeight();
  }, 100);

  window.addEventListener('resize', setChoicesHeightFunction, false);

  window.addEventListener('beforeunload', function (e) {
    console.log('leave-survey');
    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'leave-survey',
      'customEventLabel': that.last_rendered_question,
      'customEventValue': null
    });
  });
}

Consultation.prototype.loadResources = function (survey) {

  console.log('loadResources');

  if (typeof window.theme_version != "undefined" && typeof window.consultation_files != "undefined") {
    this.truth_table_json = window.consultation_files.truth_table + "?ver=" + window.theme_version;
    this.scores_json = window.consultation_files.scores + "?ver=" + window.theme_version;
    this.reports_json = window.consultation_files.reports + "?ver=" + window.theme_version;
    this.reports_truth_table_json = window.consultation_files.reports_truth_table + "?ver=" + window.theme_version;
    this.various_texts_json = window.consultation_files.various_texts + "?ver=" + window.theme_version;
  }

  var that = this;
  jQuery.getJSON(that.truth_table_json, function (truth_table_json) {
    that.truth_table = truth_table_json;
    jQuery.getJSON(that.scores_json, function (scores_json) {
      that.scores = scores_json;
      jQuery.getJSON(that.reports_json, function (reports_json) {
        that.reports = reports_json;
        jQuery.getJSON(that.reports_truth_table_json, function (reports_truth_table_json) {
          that.reports_truth_table = reports_truth_table_json;
          jQuery.getJSON(that.various_texts_json, function (various_texts_json) {
            that.various_texts = various_texts_json;
            jQuery.each(survey.getAllQuestions(), function (i, q) {
              if (typeof q.requiredErrorText != "undefined" && q.requiredErrorText == "" && that.various_texts['ERROR_EMPTY_ANSWER']) {
                q.requiredErrorText = that.various_texts['ERROR_EMPTY_ANSWER'];
              }
            });
            that.loadSurvey(survey);
          });
        });
      });
    });
  });
};

Consultation.prototype.loadSurvey = function (survey) {

  // console.log('loadSurvey');

  var that = this;

  survey.css = {
    navigationButton: "button btn-lg",
    pageTitle: "page-title"
  };

  that.data.name = "";

  survey.showQuestionNumbers = "off";
  survey.requiredText = "";
  survey.goNextPageAutomatic = false;
  survey.focusFirstQuestionAutomatic = false;
  survey.clearInvisibleValues = 'onHidden'; // clears values from answers if they are hidden
  survey.showNavigationButtons = true;
  survey.showProgressBar = "top";
  survey.pagePrevText = this.various_texts['BUTTON_PREVIOUS'];
  survey.pageNextText = this.various_texts['BUTTON_NEXT'];
  survey.completeText = this.various_texts['BUTTON_COMPLETE'];
  survey.onComplete.add(function (survey, options) {
    that.onComplete(survey, options);
  });
  survey.onCurrentPageChanging.add(function (survey, options) {
    that.onCurrentPageChanging(survey, options);
  });
  survey.onValueChanged.add(function (survey, options) {
    that.onValueChanged(survey, options);
  });
  survey.onValidateQuestion.add(function (survey, options) {
    that.onValidateQuestion(survey, options);
  });
  survey.onUpdateQuestionCssClasses.add(function (survey, options) {
    that.onUpdateQuestionCssClasses(survey, options);
  });
  survey.onAfterRenderPage.add(function (survey, options) {
    that.onAfterRenderPage(survey, options);
  });
  survey.onAfterRenderQuestion.add(function (survey, options) {
    that.onAfterRenderQuestion(survey, options);
  });
  survey.onAfterRenderSurvey.add(function (survey, options) {
    that.onAfterRenderSurvey(survey, options);
  });

  var ls = that.checkLocalStorage();
  var consultation_id = null;

  if (ls) {
    // use local storage

    console.log('use local storage');

    // console.log('load via local storage');

    // LOAD SURVEY VIA LOCAL STORAGE

    if (typeof ls.data.name != 'undefined') {
      window.name = ls.data.name;
    } else if (typeof window.name != 'undefined') {
      ls.data.name = window.name;
    }

    if (typeof ls.data.email != 'undefined') {
      window.email = ls.data.email;
    } else if (typeof window.email != 'undefined') {
      ls.data.email = window.email;
    }

    if (typeof ls.data.consultation_id != 'undefined') {
      window.consultation_id = ls.data.consultation_id;
    }

    if (typeof window.user_id != 'undefined') {
      that.user_validated = true;
      ls.data.user_id = window.user_id;
    }

    survey.data = ls.data;
    that.data = ls.data;
    that.send_data = ls.send_data;
    survey.setValue('hasExistingAccount', window.hasExistingAccount);
    survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
    // console.log('load page', ls.page);
    survey.currentPageNo = parseInt(ls.page);
    survey.render('surveyContainer');
    survey.currentPageNo = parseInt(ls.page) + 1;
    setTimeout(function () {
      that.hideLoading();
    }, 1000);

    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'resume-consultation',
      'customEventLabel': null,
      'customEventValue': null
    });
  } else {
    // don't use local storage 

    console.log('do not use local storage');

    if (!consultation_id) {
      consultation_id = (0, _getParameter2.default)("id") || window.consultation_id;
    }

    if ((0, _getParameter2.default)('restart')) {
      consultation_id = null;
    }

    if (typeof consultation_id !== 'undefined' && !isNaN(parseFloat(consultation_id))) {
      // LOAD SURVEY VIA DATABASE
      // console.log('load via database');
      consultation_id = parseFloat(consultation_id);

      jQuery.ajax({
        type: "POST",
        url: "/wp-json/process_consultation/v1/get",
        data: { id: consultation_id, type: window.consultation_type },
        beforeSend: function beforeSend(xhr) {
          // Here we set a header 'X-WP-Nonce' with the nonce
          xhr.setRequestHeader('X-WP-Nonce', that.nonce);
        }
      }).done(function (response) {
        if (response.status == "success") {
          var ev = new CustomEvent("survey-data-load");
          document.dispatchEvent(ev);
          that.data = response.data;
          that.data.user_id = response.user_id;
          that.data.consultation_id = consultation_id;
          that.data.consultation_type = response.consultation_type;
          that.data.consultation_type_slug = consultation_type_slug;
          that.data.email = response.data.email;
          that.user_validated = true;
          survey.data = response.data;
          survey.currentPageNo = parseInt(response.data.currentPageNo) + 1;
        } else {
          if (typeof window.name != 'undefined') {
            that.data.name = window.name;
            that.data.email = window.email;
            that.data.user_id = window.user_id;
            that.user_validated = true;
            survey.data = { name: window.name, email: window.email };
          }
        }
        if (typeof window.name != 'undefined') {
          survey.setValue('name', window.name);
        }
        survey.setValue('hasExistingAccount', window.hasExistingAccount);
        survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
        survey.render('surveyContainer');
        that.hideLoading();
      });

      dataLayer.push({
        'event': 'consultation-event',
        'customEventCategory': 'consultation',
        'customEventAction': 'resume-consultation',
        'customEventLabel': null,
        'customEventValue': null
      });
    } else {
      // LOAD NEW SURVEY
      // console.log('load new survey');
      if (typeof window.name != 'undefined') {
        that.data.name = window.name;
        that.data.email = window.email;
        that.data.user_id = window.user_id;
        that.data.consultation_type = window.consultation_type;
        that.data.consultation_type_slug = window.consultation_type_slug;
        that.user_validated = true;
        survey.data = { name: window.name, email: window.email };
      }
      survey.setValue('name', that.data.name);
      survey.setValue('hasExistingAccount', window.hasExistingAccount);
      survey.setValue('isUserLoggedIn', window.isUserLoggedIn);
      survey.render('surveyContainer');
      that.hideLoading();

      dataLayer.push({
        'event': 'consultation-event',
        'customEventCategory': 'consultation',
        'customEventAction': 'start-consultation',
        'customEventLabel': null,
        'customEventValue': null
      });
    }
  }

  // post id of consultation configuration
  survey.data.consultation_type = window.consultation_type;
  survey.data.consultation_type_slug = window.consultation_type_slug;

  jQuery(document).keypress(function (e) {

    var key = e.which;
    var question = survey.currentPage.questions[0];
    if (key == 13 && question.inputType == "text") // the enter key code
      {
        if (e.target.name != "password" && e.target.name != "new_password") {
          survey.setValue(question.name, e.target.value);
        }
        jQuery('.sv_next_btn').click();
      }
  });
};

Consultation.prototype.checkLocalStorage = function () {

  var useLocalStorage = false,
      that = this;

  if ((0, _getParameter2.default)('restart')) {
    that.clearLocalStorage();
    return false;
  }

  var ls_type = localStorage.getItem('gp_consultation_type');
  // if the local storage doesn't match current consultation type (post ID of configuration), clear storage and start again
  if (parseInt(ls_type) != parseInt(window.consultation_type)) {
    that.clearLocalStorage();
    return false;
  }

  if ((0, _getParameter2.default)('id')) {
    return false;
  }

  if (typeof localStorage != 'undefined' && localStorage.getItem('gp_consultation_data') && localStorage.getItem('gp_consultation_page')) {
    var ls_data = JSON.parse(localStorage.getItem('gp_consultation_data'));
    var ls_send_data = JSON.parse(localStorage.getItem('gp_consultation_send_data'));
    var ls_page = localStorage.getItem('gp_consultation_page');

    if (typeof ls_data.user_id != 'undefined') {
      // console.log('ls.user_id is defined');
      if (typeof window.user_id != 'undefined') {
        // console.log('window.user_id is defined');
        if (ls_data.user_id == window.user_id) {
          // console.log('user_ids defined and match');
          useLocalStorage = true;
        } else {
          // console.log('user_ids do not match, clear');
          that.clearLocalStorage();
        }
      } else {
        // console.log('user logged out? clear');
        that.clearLocalStorage();
      }
    } else {
      // console.log('ls.user_id is undefined');
      if (typeof window.user_id != 'undefined') {
        // console.log('window.user_id is defined');
        // console.log('user ids do not match...started consultation before logging in...has now logged in, clear');
        that.clearLocalStorage();
      } else {
        // console.log('window.user_id is undefined');
        useLocalStorage = true;
      }
    }
  }

  if (useLocalStorage) {
    return {
      data: ls_data,
      send_data: ls_send_data,
      page: ls_page
    };
  }

  return false;
};

Consultation.prototype.clearLocalStorage = function () {
  localStorage.removeItem('gp_consultation_data');
  localStorage.removeItem('gp_consultation_send_data');
  localStorage.removeItem('gp_consultation_page');
  localStorage.removeItem('gp_consultation_type');
  document.cookie = "gp_consultation=progress;path=/;Max-Age=-99999999;";
};

Consultation.prototype.onUpdateQuestionCssClasses = function (survey, options) {

  var classes = options.cssClasses;

  classes.mainRoot = "sv_qstn";

  if (options.question.getType() == "html") {
    classes.mainRoot = "sv_qstn sv_qstn--html";
  }

  if (typeof options.question.title != 'undefined') {

    if (typeof options.question.choices != 'undefined' && (options.question.choices.length == 2 || options.question.choices.length == 4)) {
      // Q15E1 is backwards compatible, marketing is new field name
      if (options.question.name == 'GettingToKnowYouQ15E1' || options.question.name == 'marketing') {
        classes.mainRoot = "sv_qstn sv_qstn--consent sv_qstn--2col";
      } else {
        classes.mainRoot = "sv_qstn sv_qstn--2col";
      }
    } else {
      if (options.question.name == 'GettingToKnowYouQ15E1' || options.question.name == 'marketing') {
        classes.mainRoot = "sv_qstn sv_qstn--consent";
      }
    }
  }
};

Consultation.prototype.onCurrentPageChanging = function (survey, options) {

  if (typeof survey.getValue('name') == 'undefined' || survey.getValue('name') == "" && this.data.name != "") {
    survey.setValue("name", this.data.name);
  }

  var surveyContainer = document.getElementById('surveyContainer');
  var slidePrevContainer = document.getElementById('slidePrevQuestionContainer');
  var slideNextContainer = document.getElementById('slideNextQuestionContainer');
  slideNextContainer.innerHTML = "";

  var slide = document.querySelector('#surveyContainer .sv_qstn');

  if (slide && window.consultation_status != "rendering") {

    var clone = slide.cloneNode(true);
    var cloneScrollTop = slide.scrollTop;

    var oldIndex = options.oldCurrentPage.visibleIndex;
    var newIndex = options.newCurrentPage.visibleIndex;

    if (oldIndex > newIndex) {
      // backwards
      slideNextContainer.innerHTML = "";
      slideNextContainer.appendChild(clone);
      document.dispatchEvent(this.slidePrevEvent);
      slideNextContainer.querySelector('.sv_qstn').scrollTop = cloneScrollTop;
    } else {
      // forwards
      slidePrevContainer.innerHTML = "";
      slidePrevContainer.appendChild(clone);
      document.dispatchEvent(this.slideNextEvent);
      slidePrevContainer.querySelector('.sv_qstn').scrollTop = cloneScrollTop;
    }
  }

  if (window.consultation_status == "rendering") {
    window.consultation_status = "idle";
  }

  this.checkPageTitle(options.oldCurrentPage, options.newCurrentPage, survey);
};

Consultation.prototype.onAfterRenderSurvey = function (survey, options) {

  var oldPage = {
    "title": "",
    "visibleIndex": -1
  };
  if (this.data.name == "") {
    // fix for first page bug if name not set
    survey.currentPageNo = 0;
  } else {
    window.consultation_status = "idle";
  }

  // dataLayer.push({
  //   'event': 'consultation-event',
  //   'customEventCategory': 'consultation',
  //   'customEventAction': 'render-survey',
  //   'customEventLabel': null,
  //   'customEventValue': null
  // });

  this.checkPageTitle(oldPage, options.survey.currentPage, survey);
};

Consultation.prototype.onAfterRenderPage = function (survey, options) {

  var thisPage = options.page.visibleIndex;

  if (options.page.visibleIndex > 0) {
    var prev_btn = document.querySelector('.sv_prev_btn');
    if (prev_btn) {
      prev_btn.style.display = "block";
    }
  }

  // disable the Next button while scrolling the slide
  var nextButton = jQuery('input.sv_next_btn');
  nextButton.prop('disabled', true);

  setTimeout(function () {
    nextButton.prop('disabled', false);
  }, 1000);

  if (options.page.maxTimeToFinish > 0 || options.page.visibleIndex == 0) {

    var transition_speed = 1000;
    var timeout = 1500 + transition_speed;

    if (options.page.maxTimeToFinish > 0) {
      timeout = parseFloat(options.page.maxTimeToFinish) * 1000 + transition_speed;
    }

    setTimeout(function () {
      if (thisPage == window.SurveyJS.currentPage.visibleIndex) {
        // if we haven't skipped through manually
        survey.nextPage();
      }
    }, timeout);
  }

  jQuery('#surveyContainer .sv_qstn fieldset').wrapInner("<div class='consultation__options'></div>");

  this.setChoicesHeight();
  this.fieldsetScrollListeners();
};

Consultation.prototype.onAfterRenderQuestion = function (survey, options) {

  this.last_rendered_question = options.question.name + " - " + options.question.title;

  if (options.question.name === 'name') {
    console.log('given name!');
    var name_input = document.querySelector('#surveyContainer .sv_qstn input[type="text"]');
    if (name_input) {
      name_input.autocomplete = 'given-name';
    }
  }

  // Q1E1 is backwards compatible, age is new field name
  else if (options.question.name == "GettingToKnowYouQ1E1" || options.question.name == "age") {
      var age_input = document.querySelector('#surveyContainer .sv_qstn input[type="text"]');
      if (age_input) {
        age_input.type = 'number';
      }
    } else if (options.question.name == "password") {
      if (survey.data.hasExistingAccount) {
        this.addPasswordField();
      } else {
        this.addNewPasswordField();
      }
    }
  if (options.question.getType() == "checkbox") {
    jQuery('#surveyContainer .alert').before('<span class="consultation__please-select-all">Please select all that apply.</span>');
  }
  if (options.question.getType() == "radiogroup") {
    if (typeof options.question.value == 'undefined' || options.question.value === null) {
      this.nextButtonVisibility(0);
    } else {
      // If they have already selected an answer and gone Back, show the Continue button as we don't want to force them to change answer.
      this.nextButtonVisibility(1);
    }
  } else {
    this.nextButtonVisibility(1);
  }

  if (typeof options.question.title != 'undefined') {
    dataLayer.push({
      'event': 'consultation-event',
      'customEventCategory': 'consultation',
      'customEventAction': 'load-question',
      'customEventLabel': options.question.title,
      'customEventValue': null
    });
  }

  var alertZone = document.querySelector('#surveyContainer .sv_qstn .alert');

  if (alertZone) {

    var observer = new MutationObserver(function () {
      jQuery('#surveyContainer .sv_qstn').animate({ scrollTop: 0 }, "fast");
    });

    observer.observe(alertZone, { childList: true });
  }

  if (typeof fbq !== 'undefined') {
    fbq('track', 'ViewContent', {
      source: 'vivewellnesspixel',
      step: survey.currentPageNo
    });
  }
};

Consultation.prototype.setChoicesHeight = function () {

  var choices = document.querySelectorAll('#surveyContainer .sv_qstn .radio label, #surveyContainer .sv_qstn .checkbox label');

  if (choices !== null) {
    var biggest_choice_height = 0;

    if (window.innerWidth >= 800) {

      for (var i = 0; i < choices.length; i++) {

        choices[i].style.height = 'auto';

        if (choices[i].offsetHeight > biggest_choice_height) {
          biggest_choice_height = choices[i].offsetHeight;
        }
      }
    }

    for (var i = 0; i < choices.length; i++) {

      if (window.innerWidth >= 800) {
        choices[i].style.height = biggest_choice_height + "px";
      } else {
        choices[i].style.height = 'auto';
      }
    }
  }
};

Consultation.prototype.onValueChanged = function (survey, options) {
  if (options.name != 'hasExistingAccount' && options.name != 'isUserLoggedIn' && options.name != 'name') {
    this.updateMaxCapsules(options);
    this.consoleLogCurrentState(survey, options);
    this.gotoNextIfPickOneQuestion(survey, options);
  }
  if (options.name === 'email') {
    var value = options.value;
    if (value) {
      // strip out any spaces from email address
      survey.setValue('email', value.replace(/\s/g, ""));
    }
  }
};

Consultation.prototype.ucwords = function (str) {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
    return $1.toUpperCase();
  });
};

Consultation.prototype.onValidateQuestion = function (survey, options) {

  this.hideDynamicAnswers(survey, options);

  var that = this;

  if (options.name == 'age') {
    if (options.value < 18) {
      options.error = this.various_texts['AGE_TOO_YOUNG'];
      return;
    }
    if (options.value > 110) {
      options.error = this.various_texts['AGE_TOO_OLD'];
      return;
    }
  }

  if (options.name == "email") {
    this.validateUser(survey, options);
  } else if (options.name == "password") {
    this.validateUser(survey, options);
  } else {
    if (options.name == 'name') {
      if (options.value != "") {
        var filteredNameLowercase = options.value.toLowerCase();
        survey.setValue("name", this.ucwords(filteredNameLowercase));
      }
    }
    this.checkForDataToSave(survey, options);
  }
};

Consultation.prototype.onComplete = function (survey, options) {

  this.last_rendered_question = 'loading-results';
  // console.log('onComplete');
  var that = this;

  dataLayer.push({
    'event': 'consultation-event',
    'customEventCategory': 'consultation',
    'customEventAction': 'complete',
    'customEventLabel': that.last_rendered_question,
    'customEventValue': null
  });

  that.changeLoadingText('Analysing your Results');
  that.showLoading();
  that.data.results = that.surveyCompleteProcessAnswers(survey);
  // console.log(that.data.results);
  that.data.completed_at = new Date().getTime();

  var utm = new _utmTracking2.default();
  var utm_data = utm.getData();
  if (utm_data) {
    that.data.utm = utm_data;
  }

  jQuery.ajax({
    type: "POST",
    url: "/wp-json/process_consultation/v1/complete",
    data: { 'data': that.data, 'send_data': that.send_data },
    beforeSend: function beforeSend(xhr) {
      // Here we set a header 'X-WP-Nonce' with the nonce
      xhr.setRequestHeader('X-WP-Nonce', that.nonce);
    }
  }).done(function (response) {
    if (response.status == "success") {
      that.changeLoadingText('Checking the Research');
      setTimeout(function () {
        that.changeLoadingText('Building your Pack');
        setTimeout(function () {
          // clear local data when consultation finished
          localStorage.removeItem('gp_consultation_data');
          localStorage.removeItem('gp_consultation_send_data');
          localStorage.removeItem('gp_consultation_page');
          localStorage.removeItem('gp_utm');
          document.cookie = "gp_consultation=complete;path=/;Max-Age=-99999999;";
          this.last_rendered_question = "redirect-to-pack";
          window.location = window.productsLoadConsultation.replace('%consultation_id%', response.consultation_id);
        }, 500);
      }, 500);
    } else {
      alert('An error occurred. Please refresh the page.');
    }
  });
};

exports.default = Consultation;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _load = __webpack_require__(24);

var _load2 = _interopRequireDefault(_load);

var _debounce = __webpack_require__(6);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import animationend from "../../util/animationend";

_load2.default.prototype.gotoNextIfPickOneQuestion = function (survey, options) {
    // if there is only one question on the page,
    // and it's a radiogroup, then automagically go to the
    // next page.
    if (!survey.goNextPageAutomatic) {
        var question = options.question;
        if (!question) return;
        var element = jQuery('#' + question.id);
        if (element.find('input[type=radio]').length > 0) {
            if (survey.currentPage.questions.length > 1) {
                // console.log('Too many questions on page to auto next');
            } else {
                // console.log('Jumping to next page');
                // we need a delay so that survey has time to readjust based on
                // answer, otherwise we progress as if we have not answered.
                setTimeout(function () {
                    survey.nextPage();
                }, 300);
            }
        } else {
            // console.log("question is not a radio");
        }
    } else {
            // console.log('goNextPageAutomatic is already set in the survey');
        }
};

_load2.default.prototype.convertQuestionnaireOutputToVarDict = function (surveyOutput) {
    var varDict = {};
    jQuery.each(surveyOutput, function (_i, v) {
        if (jQuery.isArray(v)) {
            jQuery.each(v, function (_ii, vv) {
                if (!(typeof vv == 'string' && vv.startsWith('MaxCapsules'))) {
                    // we don't want to pass MaxCapsulesN answers into the varDict
                    varDict[vv] = true;
                }
            });
        } else {
            if (!(typeof v == 'string' && v.startsWith('MaxCapsules'))) {
                // we don't want to pass MaxCapsulesN answers into the varDict
                varDict[v] = true;
            }
        }
    });
    // console.log(varDict);
    return varDict;
};

_load2.default.prototype.hideDynamicAnswers = function (survey, options) {
    var that = this;
    var varDict = this.convertQuestionnaireOutputToVarDict(survey.data);
    // find all showIf choices in survey
    var questionsWithShowIf = this.findQuestionsWithShowIfChoices(survey);
    jQuery.each(questionsWithShowIf, function (i, question) {
        that.removeChoicesIfShowIfFalse(varDict, question);
    });
};

_load2.default.prototype.findQuestionsWithShowIfChoices = function (survey) {
    // find all showIf choices in survey
    var questions = [];
    jQuery.each(survey.pages, function (i, page) {
        jQuery.each(page.questions, function (i, question) {
            var hasShowIfs = false;
            jQuery.each(question.choicesBackup ? question.choicesBackup : question.choices, function (i, choice) {
                if (choice.answerVars && choice.answerVars.showIf) {
                    hasShowIfs = true;
                }
            });
            if (hasShowIfs) {
                questions.push(question);
                // if this question hasn't backed up the choices yet, do it now.
                if (!question.choicesBackup) {
                    question.choicesBackup = question.choices.slice(); // copy it
                }
            }
        });
    });
    return questions;
};

_load2.default.prototype.consoleLogCurrentState = function (survey, options) {
    return;
    console.log('consoleLogCurrentState');
    // console.log(survey.data);
    // different to vive.js's function. use this to log products/scores as we go
    var that = this;
    var results;
    if (!this.scores) {
        jQuery.getJSON(that.truth_table_json, function (truth_table_json) {
            that.truth_table = truth_table_json;
            jQuery.getJSON(that.scores_json, function (scores_json) {
                that.scores = scores_json;
                results = that.surveyCompleteProcessAnswers(survey);
                console.log('results.reports', results.reports);
            });
        });
    } else {
        results = that.surveyCompleteProcessAnswers(survey);
        console.log('results.reports', results.reports);
    }
};

_load2.default.prototype.getQuestionTypeFromSurveyJson = function (question_id) {
    // sadly the survey itself doesn't make it clear what type of question a question is (weird),
    // so we have to look at our original json spec to find the type.
    var $qtype;
    jQuery.each(surveyJSON['pages'], function (i, page) {
        jQuery.each(page['elements'], function (ii, question) {
            if (question['name'] == question_id) $qtype = question['type'];
        });
    });
    return $qtype;
};

_load2.default.prototype.removeChoicesIfShowIfFalse = function (varDict, question) {
    question.choices = [];
    jQuery.each(question.choicesBackup, function (i, choice) {
        if (choice.answerVars && choice.answerVars.showIf) {
            if (varDict[choice.answerVars.showIf]) {
                question.choices.push(choice);
            }
        } else {
            question.choices.push(choice);
        }
    });
};

_load2.default.prototype.slideNext = function () {

    // console.log('slideNext');
    var that = this;

    var surveyContainer = document.getElementById('surveyContainer');
    var slideContainer = document.getElementById('slidePrevQuestionContainer');

    surveyContainer.classList.add('next');
    slideContainer.classList.add('next');

    document.querySelector('#slidePrevQuestionContainer.next .sv_qstn').addEventListener('animationend', function () {
        // console.log('next animationend');
        slideContainer.innerHTML = "";
        surveyContainer.classList.remove('next');
        slideContainer.classList.remove('next');
        // backup
        surveyContainer.classList.remove('prev');
        slideContainer.classList.remove('prev');

        that.focusOnTextInput();
    });
};

_load2.default.prototype.slidePrev = function () {

    // console.log('slidePrev');
    var that = this;

    var surveyContainer = document.getElementById('surveyContainer');
    var slideContainer = document.getElementById('slideNextQuestionContainer');

    surveyContainer.classList.add('prev');
    slideContainer.classList.add('prev');

    document.querySelector('#slideNextQuestionContainer.prev .sv_qstn').addEventListener('animationend', function () {
        // console.log('prev animationend');
        slideContainer.innerHTML = "";
        surveyContainer.classList.remove('prev');
        slideContainer.classList.remove('prev');
        // backup
        surveyContainer.classList.remove('next');
        slideContainer.classList.remove('next');

        that.focusOnTextInput();
    });
};

_load2.default.prototype.focusOnTextInput = function () {
    var textInput = jQuery('#surveyContainer input[type="text"], #surveyContainer input[type="email"]')[0];
    if (typeof textInput != 'undefined') {
        textInput.focus();
    }
};

_load2.default.prototype.hideAlert = function () {
    jQuery('.alert').addClass('hidden');
};

_load2.default.prototype.alertLoading = function () {
    jQuery('.alert').removeClass('hidden');
    jQuery('.alert').addClass('loading');
};

_load2.default.prototype.alertDanger = function () {
    jQuery('.alert').removeClass('hidden');
    jQuery('.alert').removeClass('loading');
};

_load2.default.prototype.changeLoadingText = function () {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    if (text) {
        this.loadingEl.querySelector('.consultation__loading-text').innerHTML = text;
    }
};

_load2.default.prototype.showLoading = function () {
    this.loadingEl.classList.add('fadeIn');
    this.loadingEl.classList.add('show');
    this.loadingEl.classList.remove('fadeOut');
};

_load2.default.prototype.hideLoading = function () {
    this.loadingEl.classList.remove('fadeIn');
    this.loadingEl.classList.remove('show');
    this.loadingEl.classList.add('fadeOut');
};

_load2.default.prototype.getPageTitles = function (survey) {

    var pages = [];
    var questions = survey.getAllQuestions(true);

    for (var i = 0; i < questions.length; i++) {
        pages.push(questions[i].page.title);
    }

    return pages.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
};

_load2.default.prototype.nextButtonVisibility = function (opacity_value) {

    var next = document.querySelector('.sv_next_btn');

    if (next) {
        next.style.opacity = opacity_value;
        if (opacity_value) {
            next.style.visibility = "visible";
        } else {
            next.style.visibility = "hidden";
        }
    }
};

_load2.default.prototype.checkPageTitle = function (oldPage, newPage, survey) {

    if (!oldPage || !newPage) {
        return;
    }

    if (oldPage.title == newPage.title) {
        return;
    }

    var that = this;

    dataLayer.push({
        'event': 'consultation-event',
        'customEventCategory': 'consultation',
        'customEventAction': 'new-section',
        'customEventLabel': newPage.title,
        'customEventValue': null
    });

    setTimeout(function () {
        that.renderPageTitles(newPage.title, that.getPageTitles(survey));
    }, 500);
};

_load2.default.prototype.renderPageTitles = function (currentPageTitle, pages) {

    var pages_html = [],
        pageIndex = 0,
        translateY = 0,
        html = "";

    for (var i = 0; i < pages.length; i++) {
        html = "";
        html += "<span class='";
        if (currentPageTitle == pages[i]) {
            html += " current ";
        }
        html += "'>";
        html += pages[i];
        html += "</span>";
        pages_html.push(html);
    }

    html = pages_html.join("");
    this.pagesElMover.innerHTML = html;

    pageIndex = pages.indexOf(currentPageTitle);
    if (pageIndex > 1) {
        translateY = -1 * (pageIndex - 1) * 28;
        if (pageIndex >= pages.length - 3) {
            translateY = -1 * (pages.length - 4) * 28;
        }
    }

    this.pagesElMover.style.transform = "translateY(" + translateY + "px) translateZ(0)";
};

_load2.default.prototype.fieldsetScrollListeners = function (fieldset) {

    var fieldset = null;

    if (window.innerWidth <= 800) {
        fieldset = document.querySelector('#surveyContainer .sv_qstn');
    } else {
        fieldset = document.querySelector('#surveyContainer .sv_qstn fieldset');
    }

    if (fieldset) {

        var that = this;

        this.checkFieldsetScroll(fieldset);
        fieldset.addEventListener('scroll', function () {
            that.checkFieldsetScroll(fieldset);
        });

        var resizeFunction = (0, _debounce2.default)(function () {
            that.checkFieldsetScroll(fieldset);
        }, 100);

        window.addEventListener('resize', resizeFunction, false);
    }
};

_load2.default.prototype.checkFieldsetScroll = function (fieldset) {

    var consultation = document.querySelector('.consultation');

    if (fieldset.scrollHeight > fieldset.clientHeight + 1) {
        fieldset.classList.add('scrollable');
        consultation.classList.add('scrollable');
        if (fieldset.offsetHeight + fieldset.scrollTop < fieldset.scrollHeight) {
            fieldset.classList.add('scrollDown');
            consultation.classList.add('scrollDown');
        } else {
            fieldset.classList.remove('scrollDown');
            consultation.classList.remove('scrollDown');
        }
        if (fieldset.scrollTop != 0) {
            fieldset.classList.add('scrollUp');
            consultation.classList.add('scrollUp');
        } else {
            fieldset.classList.remove('scrollUp');
            consultation.classList.remove('scrollUp');
        }
    } else {
        fieldset.classList.remove('scrollable');
        fieldset.classList.remove('scrollUp');
        fieldset.classList.remove('scrollDown');
        consultation.classList.remove('scrollable');
        consultation.classList.remove('scrollUp');
        consultation.classList.remove('scrollDown');
    }
};

exports.default = _load2.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _results = __webpack_require__(27);

var _results2 = _interopRequireDefault(_results);

var _handlebarsMin = __webpack_require__(67);

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_results2.default.prototype.addDietAndLifestyleBandVariables = function (varDict, scores) {
  // console.log(dietAndLifestyleScores);
  var dp = 0;
  var lp = 0;
  if (typeof scores.lifestyle != "undefined") dp = scores.lifestyle;
  varDict['ScoreLifestyleLessThan51'] = dp < 51;
  varDict['ScoreLifestyle51to75'] = dp >= 51 && dp <= 75;
  varDict['ScoreLifestyle76to85'] = dp >= 76 && dp <= 85;
  varDict['ScoreLifestyle86plus'] = dp >= 86;
  if (typeof scores.lifestyle != "undefined") lp = scores.diet;
  varDict['ScoreDietLessThan51'] = lp <= 50;
  varDict['ScoreDiet51to75'] = lp >= 51 && lp <= 75;
  varDict['ScoreDiet76to85'] = lp >= 76 && lp <= 85;
  varDict['ScoreDiet86plus'] = lp >= 86;
  return varDict;
};

_results2.default.prototype.generateReport = function (reportName, reportData) {
  // console.log(reportName);
  var sluggedReportName = slugify(reportName);
  // console.log(sluggedReportName);
  // console.log(reportData);

  this.reportContentTemplate = _handlebarsMin2.default.compile('{{#> ' + sluggedReportName + '}}{{/' + sluggedReportName + '}}');
  this.reportBaseTemplate = _handlebarsMin2.default.compile('{{> base }}');
  var $report_content = this.reportContentTemplate(reportData);
  $report_content = $.trim($report_content.replace(/<p><\/p>/g, ""));
  // console.log($report_content);
  if ($report_content) {
    var $raw_html = this.reportBaseTemplate({
      'title': reportName + " Wellness Guide",
      'content': $report_content
    });
    $raw_html = this.dedupeReportHtml($raw_html);
    return $raw_html;
  }
};

_results2.default.prototype.processHealthReports = function (varDict, extraData) {
  var that = this;
  var data = jQuery.extend(varDict, extraData);

  _handlebarsMin2.default.registerPartial('base', "{{{content}}}");

  jQuery.each(this.reports, function (key, value) {
    key = slugify(key);
    _handlebarsMin2.default.registerPartial(key, value);
  });

  return jQuery.map(that.findMatchingReports(varDict, that.reports_truth_table), function (report) {
    var content = that.generateReport(report.report, data);
    if (typeof content != "undefined") {
      return {
        "title": report.report,
        "content": content
      };
    }
  });
};

_results2.default.prototype.findMatchingReports = function (varDict, truthTable) {
  var reports = [{
    report: 'General Diet',
    priority: 0
  }, {
    report: 'General Lifestyle',
    priority: 0
  }];
  return reports;
};

_results2.default.prototype.dedupeReportHtml = function ($orig_html) {
  var that = this;
  var $raw_html = $orig_html;
  var re = "/(<span class='content'>.*?<\/span>)/gs";
  var matches = $raw_html.match(re);
  jQuery.each(matches, function (i, v) {
    var first_100_chars_of_para = v.substring(0, 100);
    var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/span>', 'gi');
    $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
  });

  re = "/(<li>.*?<\/li>)/gs";
  matches = $raw_html.match(re);
  jQuery.each(matches, function (i, v) {
    var first_100_chars_of_para = v.substring(0, 100);
    var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/li>', 'gi');
    $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
  });

  re = "/(<p>.*?<\/p>)/gs";
  matches = $raw_html.match(re);
  jQuery.each(matches, function (i, v) {
    if (v.length > 20) {
      var first_100_chars_of_para = v.substring(0, 100);
      var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/p>', 'gi');
      $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
    }
  });

  return $raw_html;
};

_results2.default.prototype.removeDuplicateRegexMatchesExceptFirst = function (string, regex) {
  var count = 0;
  var replaceWith = '<!-- Dupe Content Deleted -->';
  return string.replace(regex, function (match) {
    count++;
    if (count === 1) {
      return match;
    } else {
      return replaceWith;
    }
  });
};

/**
 * Slugify a string
 * @param {String} text
 * @return {String}
 */
function slugify(text) {
  return text.toString().toLowerCase().replace(/([å,ä])/g, 'a') // Replace å and ä with aa
  .replace(/(ö)/g, 'o') // Replace ö with o 
  .replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
}

function regexEscape(str) {
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

exports.default = _results2.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(28);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_user2.default.prototype.processScore = function (survey, varDict, scores, scoreName) {
    var that = this;
    var $percentage = that.calculateScore(varDict, survey, scores, scoreName);
    if (!isNaN($percentage)) {
        return Math.round($percentage, 0);
    }
    return 0;
};

_user2.default.prototype.processAnswersScores = function (varDict, survey) {
    var that = this;
    var scores = {};
    scores.diet = that.processScore(survey, varDict, this.scores, "Diet");
    scores.lifestyle = that.processScore(survey, varDict, this.scores, "Lifestyle");
    return scores;
};

_user2.default.prototype.processGoalsFocus = function (varDict, products) {
    var $focusGoal = "not found";
    var $finalGoal = null;
    // look for *GoalPriority true in varDict  
    jQuery.each(varDict, function (k, v) {
        if (v && k.match(/GoalPriority$/)) $focusGoal = k.replace("GoalPriority", "");
    });

    if ($focusGoal != "not found") {
        // Do any of the products have this as a goal?
        jQuery.each(products, function (i, reason) {
            jQuery.each(reason, function (i, product) {
                jQuery.each(product['relatedgoals'], function (ii, relatedgoal) {
                    if (relatedgoal == $focusGoal) {
                        $finalGoal = $focusGoal;
                    }
                });
            });
        });
    }

    if ($finalGoal) {
        return $finalGoal;
    }
    return $focusGoal;
};

_user2.default.prototype.processGoalsOther = function (varDict, products, focusgoal) {

    var that = this;
    var $otherGoals = [];
    // pull goals from products recommended cross referenced wiuth varDict
    jQuery.each(products, function (productName, productInfo) {
        // console.log("processGoalsOther", productName, productInfo[0], productInfo[0].relatedgoals);
        jQuery.each(productInfo[0].relatedgoals, function (i, goalName) {
            // console.log(goalName);
            if (goalName) {
                var $minGoalname = goalName.replace("Goal", "");
                if ($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                    $otherGoals.push($minGoalname);
                }
            }
            /*
            if(varDict[goalName]) {
              console.log("isTrue", goalName);
              var $minGoalname = goalName.replace("Goal", "");
              if($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                console.log("not in list, add", $minGoalname);
                $otherGoals.push($minGoalname);
              }
            }
            */
        });
    });

    jQuery.each(that.cachedOtherGoalsThatWereCut, function (i, goalName) {
        if (goalName) {
            var $minGoalname = goalName.replace("Goal", "");
            if ($minGoalname != focusgoal && $otherGoals.indexOf($minGoalname) == -1) {
                $otherGoals.push($minGoalname);
            }
        }
    });

    // jQuery("#goalsOther").html(
    //     "<div class='text-center'>Other Goals<br /><b>" + $otherGoals.join(", ") + "</b></div>"
    // );

    return $otherGoals;
};

_user2.default.prototype.setMainGoalIfOnlyOneGoal = function (varDict) {
    // count how many *Goal and *PriorityGoal truths there are.
    // If it's 1 *Goal and 0 *PriorityGoal then set the *PriorityGoal
    // But what happens if they select another one? Do we disable all *PriorityGoals?
    var numGoals = 0;
    var numPriorityGoals = 0;
    var lastGoalName = '';
    jQuery.each(varDict, function (k, v) {
        if (v) {
            if (k.match(/GoalPriority$/)) {
                // console.log(k)
                numPriorityGoals++;
            } else if (k.match(/Goal$/)) {
                // console.log(k)
                numGoals++;
                lastGoalName = k;
            }
        }
    });

    // console.log(numGoals, numPriorityGoals);

    if (numGoals == 1 && numPriorityGoals == 0) {
        // console.log(lastGoalName.replace(/Goal$/,"GoalPriority"));
        varDict[lastGoalName.replace(/Goal$/, "GoalPriority")] = true;
    }
    // console.log(varDict);
    return varDict;
};

_user2.default.prototype.processGoals = function (varDict, products) {
    // jQuery("#goalsContainer").html(
    //     "<div class='row top-buffer'><div id='goalsFocus' class='col-sm-6' /><div id='goalsOther' class='col-sm-6' /></div>"
    // );

    var $focusGoal = this.processGoalsFocus(varDict, products);
    var $otherGoals = this.processGoalsOther(varDict, products, $focusGoal);

    return { focusGoal: $focusGoal, otherGoals: $otherGoals };
};

_user2.default.prototype.displayName = function (survey) {
    var q = survey.getQuestionByName("name");
    return q.value;
};

_user2.default.prototype.replaceProducts = function (products) {

    var replacedProducts = {};

    var count = 0;
    jQuery.each(products, function (k, product) {
        count++;
        switch (count) {
            case 1:
                replacedProducts["Calcium"] = product;
                break;
            case 2:
                replacedProducts["Omega 3 + D3"] = product;
                break;
        }
    });

    return replacedProducts;
};

_user2.default.prototype.processAllergiesAndDiet = function (varDict) {
    //   $('#allergiesAndDietContainer').html("<div class='row text-center top-buffer'><div class='col-sm-6' id='allergiesContainer' /><div class='col-sm-6' id='dietContainer' /></div>");

    var allergies = [];
    var diets = [];
    jQuery.each(varDict, function (varName, varVal) {
        if (varVal && varName.startsWith("FoodAllergies") && varName != 'FoodAllergiesNone') {
            var name = varName.replace('FoodAllergies', '') + '-Free';
            allergies.push(name);
        }

        if (varVal && varName.startsWith("Diet") && varName != 'DietNone') {
            var name = varName.replace('Diet', '').replace('Free', '-Free');
            if (jQuery.inArray(name, allergies) == -1) {
                diets.push(name);
            }
        }
    });

    return { allergen_info: allergies, dietary_restrictions: diets };
};

_user2.default.prototype.surveyCompleteProcessAnswers = function (survey) {
    // console.log('surveyCompleteProcessAnswers');
    // clear survey and prepare the screen for results.
    var varDict = this.convertQuestionnaireOutputToVarDict(survey.data);
    varDict = this.setMainGoalIfOnlyOneGoal(varDict);
    var products = this.processProducts(varDict, survey, this.MaxCapsules);
    // below line for testing with hardcoded products only
    // products = this.replaceProducts(products);
    var scores = this.processAnswersScores(varDict, survey);
    varDict = this.addDietAndLifestyleBandVariables(varDict, scores);
    var goals = this.processGoals(varDict, products);
    var name = this.displayName(survey);
    var dietary_requirements = this.processAllergiesAndDiet(varDict);
    var extraData = {
        'ScoreDiet': scores.diet ? scores.diet : 0,
        'ScoreLifestyle': scores.lifestyle ? scores.lifestyle : 0
    };
    var reports = this.processHealthReports(varDict, extraData);

    return {
        // responses: varDict,
        products: products,
        scores: scores,
        goals: goals,
        name: name,
        dietary_requirements: dietary_requirements,
        reports: reports

        // $.ajax({
        //   type: "POST",
        //   url: "save_survey.php",
        //   data: {
        //     responses: varDict,
        //     products: products
        //   },
        //   success: function() {
        //     alert("Saved!");
        //   },
        //   dataType: "json"
        // });
    };
};

_user2.default.prototype.calculateScore = function (varDict, survey, scores, scoreName) {
    var min = 0;
    var max = 0;
    var numAnswers = 0;
    var totalScore = 0;

    var answers = survey.data;
    var questions = survey.getAllQuestions(true); // don't include invisible questions
    jQuery.each(questions, function (i, question) {
        jQuery.each(question.choices, function (k, v) {
            if (scores[scoreName]) {
                var $choiceScore = scores[scoreName][v['itemValue']];
                if ($choiceScore) {
                    // console.log(v, varDict[v['itemValue']], $choiceScore);
                    if ($choiceScore > max) max = $choiceScore;
                    if ($choiceScore < min) min = $choiceScore;
                    if (varDict[v['itemValue']] && $choiceScore != 0) {
                        numAnswers++;
                        totalScore += $choiceScore;
                    }
                }
            }
        });
    });
    var avg = totalScore / numAnswers;
    var onePercent = (max - min) / 100;
    var percentage = (avg - min) / onePercent;
    // console.log(min,max,numAnswers,totalScore,avg,percentage);
    return 50 + percentage / 2;
};

_user2.default.prototype.processProducts = function (varDict, survey, maxCapsules) {
    var that = this;
    var products = this.findMatchingProducts(varDict, this.truth_table);
    // console.log("after findMatchingProducts", products);
    products = this.removeExclusions(products, this.truth_table);
    // console.log("after removeExclusions", products);
    products = this.removeAllButTheHighestPriorityProductsCappedAtEightCapsules(products, this.truth_table, maxCapsules);
    // console.log("after removeAllButTheHighestPriorityProductsCappedAtEightCapsules", products);
    return products;
};

_user2.default.prototype.removeAllButTheHighestPriorityProductsCappedAtEightCapsules = function (products, truthTablem, maxCapsules) {

    var that = this;

    // first we remove all but the highest priority reasons for each product.
    jQuery.each(products, function (k, product) {
        // sort by priority (lower is higher)
        products[k] = product.sort(function (a, b) {
            return a.priority - b.priority;
        });
        products[k].length = 1; // truncate to first item
    });

    // annotate name into products so we can sort the values
    // without losing the key.
    var productsAsList = [];
    jQuery.each(products, function (k, product) {
        products[k][0]['_Name'] = k;
        productsAsList.push(products[k]);
    });

    // sort product list by priority (of remaining reason, should only be 1 now)
    productsAsList = productsAsList.sort(function (a, b) {
        return a[0].priority - b[0].priority;
    });

    // console.log("ORD", productsAsList);

    // now it's in order pull out products until we have
    // no space for any more capsules.
    products = {};
    this.cachedOtherGoalsThatWereCut = [];
    jQuery.each(productsAsList, function (i, product) {
        if (product[0].capsules <= maxCapsules) {
            maxCapsules -= product[0].capsules;
            products[product[0]['_Name']] = product;
        } else {
            // NOTE: we cache all of the Related/Other Goals from the
            // prods we're cutting so we can include them later.
            jQuery.each(product[0].relatedgoals, function (i, v) {
                if (v) {
                    // console.log(v);
                    if (that.cachedOtherGoalsThatWereCut.indexOf(v) == -1) {
                        that.cachedOtherGoalsThatWereCut.push(v);
                    }
                }
            });
        }
    });

    // console.log(that.cachedOtherGoalsThatWereCut);

    // console.log("CAP", products);

    return products;
};

_user2.default.prototype.getCombineGroupLookup = function (truthTable) {
    var combineGroupLUT = {};
    jQuery.each(truthTable, function (productName, data) {
        var combineGroupNamesList = data['_CombineWith'];
        jQuery.each(combineGroupNamesList, function (_, combineGroupName) {
            if (!combineGroupLUT[combineGroupName]) {
                combineGroupLUT[combineGroupName] = [productName];
            } else {
                combineGroupLUT[combineGroupName].push(productName);
            }
        });
    });
    return combineGroupLUT;
};

_user2.default.prototype.combineProducts = function (products, truthTable) {
    var combineGroupLUT = this.getCombineGroupLookup(truthTable);
    // console.log(combineGroupLUT);

    // look at each group. if all products in a group
    // have been selected then combine them into one product.
    jQuery.each(combineGroupLUT, function (combineGroupName, productsInGroup) {
        // console.log(combineGroupName +" "+ productsInGroup);
        var allProductsSelected = true;
        jQuery.each(productsInGroup, function (_, productInGroupName) {
            if (!products[productInGroupName]) {
                allProductsSelected = false;
            }
        });
        if (allProductsSelected) {
            // console.log("Combine group '" + combineGroupName + "' HAS all its products selected. Merging them.");
            var combinedReasons = [];
            jQuery.each(productsInGroup, function (_, productInGroupName) {
                jQuery.each(products[productInGroupName], function (_, reason) {
                    combinedReasons.push(productInGroupName + " as " + reason);
                });
                delete products[productInGroupName];
            });
            products[combineGroupName] = combinedReasons;
        } else {
            // console.log("Combine group '" + combineGroupName + "' does NOT have all its products selected.");
        }
    });

    return products;
};

_user2.default.prototype.removeExclusions = function (products, truthTable) {
    var productsMinusExclusions = {};
    jQuery.each(products, function (productName, reasons) {
        var unexcluded_reasons = [];
        jQuery.each(reasons, function (i, reason) {
            var excludeIfWithList = reason['excludeifwith'];
            // are ANY of the named products also selected? if so, exclude this one.
            var excluded = false;
            jQuery.each(excludeIfWithList, function (_, excludeIfWith) {
                if (products[excludeIfWith]) {
                    excluded = true;
                    // console.log("Excluded "+productName+" as ExcludeIfWith "+excludeIfWith);
                }
            });
            if (!excluded) {
                unexcluded_reasons.push(reason);
            }
        });
        if (unexcluded_reasons && unexcluded_reasons.length > 0) {
            productsMinusExclusions[productName] = unexcluded_reasons;
        }
    });
    return productsMinusExclusions;
};

_user2.default.prototype.processVarNameAndValue = function (varDict, truthVar, truthVal) {
    // Turn our TT varname of "Var1 and (Var2 or Var3)" into some JS we can eval.
    // Most of the time it'll likely be just a single name that matches the varDict.
    // console.log("START processVarNameAndValue", truthVar);
    if (!truthVar) return;
    truthVar = String(truthVar).replace(/[a-zA-Z0-9+-]+/g, function (varName) {
        // console.log("REPLACE processVarNameAndValue", varName);
        var replaceVal;
        if (varName == 'or') {
            replaceVal = '||';
        } else if (varName == 'and') {
            replaceVal = '&&';
        } else {
            replaceVal = varDict[varName] ? 'true' : 'false';
        }
        // console.log("REPLACE processVarNameAndValue", varName, replaceVal);
        return replaceVal;
    });
    // console.log("MID processVarNameAndValue", truthVar);
    var response = eval(truthVar) == truthVal;
    // console.log("END processVarNameAndValue", response);
    return response;
};

_user2.default.prototype.findMatchingProducts = function (varDict, truthTable) {
    var products = {};
    var that = this;
    jQuery.each(truthTable, function (productName, truthOptions) {
        jQuery.each(truthOptions, function (reason, truth) {
            var viable = true;
            // console.log(productName+" "+reason);
            var priority = truth['_Priority'];
            var capsules = truth['_Capsules'];
            var excludeifwith = truth['_ExcludeIfWith'];

            // give the priority a boost if this product is in 
            // a focus goal area.
            var relatedgoals = truth['_RelatedGoals'];
            var focusgoals = truth['_FocusGoals'];
            var hasFocusGoal = false;
            jQuery.each(focusgoals, function (i, goalVarName) {
                if (varDict[goalVarName]) hasFocusGoal = true;
            });
            if (hasFocusGoal) {
                priority -= 30;
            }

            // console.log(truth);
            jQuery.each(truth, function (truthVar, truthVal) {
                if (truthVar[0] != "_") {
                    if (!that.processVarNameAndValue(varDict, truthVar, truthVal)) {
                        viable = false;
                    }
                }
            });
            if (viable) {
                // console.log("Product selected: " + productName);
                if (!products[productName]) {
                    products[productName] = [];
                }
                products[productName].push({ "reason": reason, "priority": priority, "capsules": capsules, "relatedgoals": relatedgoals, "excludeifwith": excludeifwith });
            }
        });
    });
    return products;
};

_user2.default.prototype.summarizeProducts = function (products) {
    var text = "";
    jQuery.each(products, function (product, reasons) {
        text += "<div class='row top-buffer'>";
        text += "<ul class='col-sm list-group'>";
        text += "<li class='list-group-item active'>" + product + "</li>";
        jQuery.each(reasons, function (_i, info) {
            text += "<li class='list-group-item'>" + info['reason'] + " <small>[ DEBUG: priority: " + info['priority'] + " capsules: " + info['capsules'] + " relatedgoals: " + info['relatedgoals'] + " ]</small></li>";
        });
        text += "</ul>";
        text += "</div>";
    });
    return text;
};

_user2.default.prototype.updateMaxCapsules = function (options) {
    // side effect to manage MaxCapsulesN only being set to the last
    // one selected.
    if (options && options.value && typeof options.value == 'string' && options.value.startsWith('MaxCapsules')) {
        // console.log(options.value);
        this.MaxCapsules = parseInt(options.value.replace('MaxCapsules', ''));
        // console.log(MaxCapsules);
    }
};

exports.default = _user2.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navigation = __webpack_require__(25);

var _navigation2 = _interopRequireDefault(_navigation);

var _utmTracking = __webpack_require__(7);

var _utmTracking2 = _interopRequireDefault(_utmTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_navigation2.default.prototype.validateUser = function (survey, options) {
    jQuery(".alert").text(""); // hard reset

    // console.log('validateUser');

    if (options.name == "email") {
        if (options.value != this.data.email) {
            // check if email has changed/is not set
            // console.log('email different');
            this.data.email = options.value;
            this.send_data.email = options.value;
            this.user_validated = false;
            survey.setValue("hasExistingAccount", false);
            survey.setValue("isUserLoggedIn", false);
            this.checkUser(this.data, survey);
        } else {
            window.consultation_status = "email_checked";
        }

        if (window.consultation_status == "email_checked") {
            // console.log('email checked');
            window.consultation_status = "idle";
            return;
        }
    }

    if (options.name == "password") {
        if (window.consultation_status == "logged_in") {
            window.consultation_status = "idle";
            return;
        }

        var password_field = document.querySelector("[name=password]");
        var password_container = document.querySelector(".password_container");
        var new_password_field = document.querySelector("[name=new_password]");
        var new_password_container = document.querySelector(".new_password_container");

        if (password_field) {
            // need to log in user
            if (password_field.value) {
                this.loginUser(this.data, password_field.value, survey, options);
            } else {
                this.alertDanger();
                options.error = "Please enter a password.";
                return;
            }
        }

        if (new_password_field) {
            // need to create user with entered password
            if (new_password_field.value) {
                if ((window.password_meets_min_reqs(new_password_field.value) || window.new_password_strength > 2) && jQuery('input[name="terms_conditions"]:checked').length > 0) {
                    this.createUser(this.data, new_password_field.value, survey);
                } else {
                    // if (this.new_password_strength != 2 &&this.new_password_strength != 3 && this.new_password_strength != 4 && !window.password_min_reqs(new_password_field.value)) {
                    if (!window.password_meets_min_reqs(new_password_field.value) && window.new_password_strength <= 2) {
                        this.alertDanger();
                        options.error = "Please enter a stronger password (6 characters minimum, including letters and numbers)";
                        return;
                    } else {
                        this.alertDanger();
                        options.error = "Please confirm you agree to our Terms & Conditions and Privacy Policy.";
                        return;
                    }
                }
            } else {
                this.alertDanger();
                options.error = "Please enter a password.";
                return;
            }
        }
    }

    if (!this.user_validated) {
        this.alertLoading();
        options.error = "Checking your details...";
    }
};

_navigation2.default.prototype.checkUser = function (data, survey) {
    var that = this;
    data.consultation_nonce = window.consultation_nonce;
    jQuery.ajax({
        type: "POST",
        url: "/wp-json/process_consultation/v1/check",
        data: data
        // beforeSend: function (xhr) {
        //     // Here we set a header 'X-WP-Nonce' with the nonce
        //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
        // },
    }).done(function (response) {
        that.hideAlert();

        if (typeof response.user_id != "undefined") {
            that.data.user_id = response.user_id;
            survey.setValue("hasExistingAccount", true);

            // if existing user
            if (!response.logged_in) {
                survey.setValue("isUserLoggedIn", false);
            } else {
                that.user_validated = true;
                survey.setValue("isUserLoggedIn", true);
            }
        }
        // console.log('next page');
        window.consultation_status = "email_checked";
        survey.nextPage();
    }).fail(function (xhr, status, error) {
        // console.log(xhr);
        // console.log(status);
        // console.log(error);
        dataLayer.push({
            'event': 'consultation-event',
            'customEventCategory': 'consultation',
            'customEventAction': 'check-user-error',
            'customEventLabel': xhr.responseText,
            'customEventValue': null
        });
    });
};

_navigation2.default.prototype.addPasswordField = function () {
    // console.log('addPasswordField');

    var password_input = document.querySelector(".sv_qstn input");
    var existing_password = document.querySelector("[name='password']");
    if (password_input && existing_password == null) {
        password_input.style.display = "none";
        var input = document.createElement("input");
        input.type = "password";
        input.name = "password";
        var password_container = document.createElement("div");
        password_container.className = "password_container";
        password_container.appendChild(input);
        password_container.innerHTML += "<p><a href='/my-account/lost-password' target='_blank'>Forgot your password?</a></p>";
        password_input.parentNode.insertBefore(password_container, password_input.nextSibling);
    }
};

_navigation2.default.prototype.addNewPasswordField = function () {
    // console.log('addNewPasswordField');

    var that = this;

    var password_input = document.querySelector(".sv_qstn input");
    var existing_password = document.querySelector("[name='new_password']");
    if (password_input && existing_password == null) {
        password_input.style.display = "none";
        var password_container = document.createElement("div");
        password_container.className = "new_password_container";
        password_container.innerHTML += "<div class='password_input'><input type='password' name='new_password' class='new_password' placeholder='Please enter a password' /><span id='password_strength' class='woocommerce-password-strength'></span></div>";
        password_container.innerHTML += "<p><input type='checkbox' class='checkbox--alt' name='terms_conditions' id='terms_conditions' /> <label for='terms_conditions'>I have read and accept the <a href='../../terms-conditions' target='_blank'>Terms & Conditions</a> and <a href='../../privacy-policy' target='_blank'>Privacy Policy</a>.</label></p>";
        password_input.parentNode.insertBefore(password_container, password_input.nextSibling);

        // Binding to trigger checkPasswordStrength
        // https://premium.wpmudev.org/forums/topic/trying-to-add-password-strength-to-signup-form
        jQuery("body").on("keyup", "input[name=new_password]", function (event) {
            window.checkPasswordStrength(jQuery("input[name=new_password]"), jQuery("#password_strength"), [], false);
        });
    }
};
/*
Consultation.prototype.checkPasswordStrength = function ( $pass1, $strengthResult, blacklistArray ) {
    
    // console.log('checkPasswordStrength');

    var pass1 = $pass1.val();
    var pass2 = null;

    // Reset the form & meter
    // $submitButton.attr( 'disabled', 'disabled' );
    $strengthResult.removeClass( 'short bad good strong' );

    // Extend our blacklist array with those from the inputs & site data
    blacklistArray = blacklistArray.concat( wp.passwordStrength.userInputBlacklist() )

    // Get the password strength
    window.new_password_strength = wp.passwordStrength.meter( pass1, blacklistArray, pass2 );

    // Add the strength meter results
    switch ( this.new_password_strength ) {

        case 2:
            $strengthResult.addClass( 'bad' ).html( pwsL10n.bad );
            break;

        case 3:
            $strengthResult.addClass( 'good' ).html( pwsL10n.good );
            break;

        case 4:
            $strengthResult.addClass( 'strong' ).html( pwsL10n.strong );
            break;

        case 5:
            $strengthResult.addClass( 'short' ).html( pwsL10n.mismatch );
            break;

        default:
            $strengthResult.addClass( 'short' ).html( pwsL10n.short );

    }

    return;
}
*/

_navigation2.default.prototype.loginUser = function (data, password, survey, options) {
    var data = {
        email: data.email,
        password: password,
        consultation_nonce: window.consultation_nonce
    };
    var that = this;

    jQuery.ajax({
        type: "POST",
        url: "/wp-json/process_consultation/v1/login",
        data: data
        // beforeSend: function (xhr) {
        //     // Here we set a header 'X-WP-Nonce' with the nonce
        //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
        // },
    }).done(function (response) {
        if (response.status == "success") {
            // console.log('logged-in');
            that.nonce = response.nonce;
            that.user_validated = true;
            window.consultation_status = "logged_in";
            survey.nextPage();
            survey.setValue("hasExistingAccount", true);
            survey.setValue("isUserLoggedIn", true);
            survey.setValue("email", data.email); // email question gets hidden so we need to set the value again
        } else {
            that.alertDanger();
            jQuery(".alert").text("Invalid details");
            var label = 'Invalid details';
            // if (typeof response.message !== 'undefined') {
            //     label = response.message;
            // }
            dataLayer.push({
                'event': 'consultation-event',
                'customEventCategory': 'consultation',
                'customEventAction': 'login-user-error',
                'customEventLabel': label,
                'customEventValue': null
            });
        }
    }).fail(function (xhr, status, error) {
        // console.log(xhr);
        // console.log(status);
        // console.log(error);
        dataLayer.push({
            'event': 'consultation-event',
            'customEventCategory': 'consultation',
            'customEventAction': 'login-user-error',
            'customEventLabel': xhr.responseText,
            'customEventValue': null
        });
    });
};

_navigation2.default.prototype.createUser = function (data, password, survey) {
    var that = this;

    var data = {
        email: data.email,
        password: password,
        name: data.name,
        consultation_nonce: window.consultation_nonce
    };

    var utm = new _utmTracking2.default();
    var utm_data = utm.getData();
    if (utm_data) {
        data.utm = utm_data;
    }

    jQuery.ajax({
        type: "POST",
        url: "/wp-json/process_consultation/v1/create",
        data: data
        // beforeSend: function (xhr) {
        //     // Here we set a header 'X-WP-Nonce' with the nonce
        //     xhr.setRequestHeader('X-WP-Nonce', that.nonce);
        // },
    }).done(function (response) {
        if (response.status == "success") {
            that.nonce = response.nonce;
            that.data.user_id = response.user_id;
            that.data.created_at = ~~(Date.now() / 1000);
            that.send_data.created_at = ~~(Date.now() / 1000);
            window.consultation_status = "logged_in";
            survey.nextPage();
            survey.setValue("hasExistingAccount", true);
            survey.setValue("isUserLoggedIn", true);
            survey.setValue("email", data.email); // email question gets hidden so we need to set the value again
            that.user_validated = true;
        } else {
            var label = 'Unknown error';
            if (typeof response.message !== 'undefined') {
                label = response.message;
            }
            dataLayer.push({
                'event': 'consultation-event',
                'customEventCategory': 'consultation',
                'customEventAction': 'create-user-error',
                'customEventLabel': label,
                'customEventValue': null
            });
        }
    }).fail(function (xhr, status, error) {
        // console.log(xhr);
        // console.log(status);
        // console.log(error);
        dataLayer.push({
            'event': 'consultation-event',
            'customEventCategory': 'consultation',
            'customEventAction': 'create-user-error',
            'customEventLabel': xhr.responseText,
            'customEventValue': null
        });
    });
};

_navigation2.default.prototype.checkForDataToSave = function (survey, options) {
    // console.log('checkForDataToSave');

    // save to WP every X fields
    var fieldsGroup = 5;

    if (typeof options != "undefined") {
        var key = options.name,
            value = options.value;

        if (options.name == "name") {
            value = this.ucwords(value);
        }

        this.data[key] = value;
        this.send_data[key] = value;
    }

    var all_questions = survey.getAllQuestions(false);

    var isQuestion; // use to check if key is an actual question or something we've added to data like user_id.

    for (var question in this.data) {
        isQuestion = false;

        if (question != "name" && question != "email" && question != "GettingToKnowYouQ15E1" && question != "marketing") {
            // if question has been removed/hidden, delete value
            if (!survey.data.hasOwnProperty(question)) {
                for (var i = 0; i < all_questions.length; i++) {
                    if (all_questions[i].name == question) {
                        isQuestion = true;
                        break;
                    }
                }

                if (isQuestion) {
                    delete this.data[question];
                    this.send_data[question] = null; // send to remove value from customer.io
                }
            }
        }
    }
    if (Array.isArray(options.value)) {
        var firstSelectedValue = options.value[0];
        if (firstSelectedValue.slice(firstSelectedValue.length - 4) == "Goal") {
            // If we save on this goals question, we might reload on the priority question
            // If we load survey on the 'what's your priority goal' question, it will show all options instead of those they selected in this question
            // So we don't want to save on this question (but we will still save question data later once they have selected priority)
            return;
        }
    }

    if (typeof localStorage != "undefined") {
        // local storage
        localStorage.gp_consultation_type = window.consultation_type;
        localStorage.gp_consultation_data = JSON.stringify(this.data);
        localStorage.gp_consultation_send_data = JSON.stringify(this.send_data);
        localStorage.gp_consultation_page = survey.currentPageNo;

        // cookie
        var date = new Date();
        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toGMTString();
        document.cookie = "gp_consultation=" + window.consultation_type + ";path=/;" + expires;
    }

    if (this.data.user_id) {
        if (Object.keys(this.send_data).length >= fieldsGroup && !survey.isLastPage) {
            this.data.currentPageNo = survey.currentPageNo;
            this.addData(survey, options);
        }
    }
};

_navigation2.default.prototype.addData = function (survey, options) {
    this.send_data.user_id = this.data.user_id;

    if (jQuery.isEmptyObject(this.sent_data)) {
        if (this.saveError === true) {
            this.saveError = false;
            // they had previously received the "We’re busy processing your answers" message, but have now been able to move through.
            console.log("saveError cleared");
            dataLayer.push({
                event: "consultation-event",
                customEventCategory: "consultation",
                customEventAction: "continued-after-save-error",
                customEventLabel: "Saving error cleared",
                customEventValue: null
            });
        }
        this.sent_data = this.send_data;
        this.send_data = {};
        var that = this;

        // console.log('saving...');

        // console.log(that.data);

        jQuery.ajax({
            type: "POST",
            url: "/wp-json/process_consultation/v1/send",
            data: { data: that.data, send_data: that.sent_data },
            beforeSend: function beforeSend(xhr) {
                // Here we set a header 'X-WP-Nonce' with the nonce
                xhr.setRequestHeader("X-WP-Nonce", that.nonce);
            }
        }).done(function (response) {
            if (response.status == "success") {
                that.data.consultation_id = response.consultation_id;
                that.sent_data = {};
            } else {
                options.error = "An error occured. Please refresh the page";
            }
        });
    } else {
        // we are still waiting for last ajax call to finish, pause to stop queries queuing up

        if (this.saveError === true) {
            // save error twice in a row, may indicate bug/issue
            console.log("saveError twice in a row");
            dataLayer.push({
                event: "consultation-event",
                customEventCategory: "consultation",
                customEventAction: "save-error",
                customEventLabel: "Saving error twice in a row",
                customEventValue: null
            });
        }

        this.saveError = true;
        options.error = "We’re busy processing your answers. Please wait a few seconds and submit your answer again";
    }
};

exports.default = _navigation2.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
function Faq() {
    this.init();
}

Faq.prototype.init = function () {
    jQuery('.faq__question').click(function () {
        jQuery(this).siblings('.faq__answer').slideToggle();
        jQuery(this).parent('.faq').toggleClass('open');
    });

    jQuery('.selectblock--faq li').click(function () {

        jQuery('.selectblock__header').removeClass('clicked');
        jQuery('.selectblock__options').removeClass('show');

        var slug = jQuery(this).data('value');
        var text = jQuery(this).text();

        jQuery('.selectblock__header').text(text);

        jQuery('.faq').each(function () {
            if (jQuery(this).hasClass(slug)) {
                jQuery(this).slideDown();
            } else {
                jQuery(this).slideUp();
            }
        });
    });
};

exports.default = Faq;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debounce = __webpack_require__(5);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header() {
    var that = this;
    this.el = document.querySelector('.header');
    this.content = document.querySelector('.wrapper');

    function scroll() {
        if (window.pageYOffset < 100) {
            that.el.classList.remove('is-small');
            that.content.classList.remove('header-is-small');
        } else {
            that.el.classList.add('is-small');
            that.content.classList.add('header-is-small');
        }
    };

    // window.addEventListener('scroll', Debounce(scroll, 10));
    window.addEventListener('scroll', function () {
        scroll();
    });

    if (window.location.hash) {
        this.el.classList.remove('show');
    }
} /* jslint es6 */
exports.default = Header;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
// https://github.com/CodyHouse/animated-headline/

function Headline($headlines, delay) {

    var animationDelay = 2500;

    // singleLetters($headlines.find('b'));

    animateHeadline($headlines, delay);

    function singleLetters($words) {
        $words.each(function () {
            var word = $(this),
                letters = word.text().split(''),
                selected = word.hasClass('is-visible');
            for (var i in letters) {
                letters[i] = selected ? '<i class="in">' + letters[i] + '</i>' : '<i>' + letters[i] + '</i>';
            }
            var newLetters = letters.join('');
            word.html(newLetters);
        });
    }

    function animateHeadline($headlines, delay) {
        $headlines.each(function () {
            var headline = $(this);
            //trigger animation
            setTimeout(function () {
                hideWord(headline.find('.is-visible'));
            }, animationDelay);
            //other checks here ...
        });
    }

    function hideWord($word) {
        var nextWord = takeNext($word);
        switchWord($word, nextWord);
        setTimeout(function () {
            hideWord(nextWord);
        }, animationDelay);
    }

    function takeNext($word) {
        return !$word.is(':last-child') ? $word.next() : $word.parent().children().eq(0);
    }

    function switchWord($oldWord, $newWord) {
        $oldWord.removeClass('is-visible').addClass('is-hidden');
        $newWord.removeClass('is-hidden').addClass('is-visible');
    }

    function hideWord($word) {
        var nextWord = takeNext($word);
        switchWord($word, nextWord);
        setTimeout(function () {
            hideWord(nextWord);
        }, animationDelay);
    }

    function takeNext($word) {
        return !$word.is(':last-child') ? $word.next() : $word.parent().children().eq(0);
    }

    function switchWord($oldWord, $newWord) {
        $oldWord.removeClass('is-visible').addClass('is-hidden');
        $newWord.removeClass('is-hidden').addClass('is-visible');
    }
}

exports.default = Headline;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debounce = __webpack_require__(5);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Layout() {

    // this.header_clear = document.querySelector(".header__clear");
    // this.footer_clear = document.querySelector(".footer__clear");
    this.footer = document.querySelector(".footer");
    this.header = document.querySelector(".header");
    // this.wrapper = document.querySelector(".wrapper");
    this.header_height;
    this.footer_height;

    var that = this;

    jQuery(document).ready(function () {
        that.init();
    });

    // jQuery(window).resize(function() {
    //     that.setHeaderClearHeight();
    //     that.setFooterClearHeight();
    // });
}

Layout.prototype.init = function () {
    this.setHeaderClearHeight();
    // this.setFooterClearHeight();
    this.initHeaderScrollListener();
};

Layout.prototype.setFooterClearHeight = function () {
    this.footer_height = this.footer.getBoundingClientRect().height;
    // this.footer_clear.style.height = this.footer_height + "px";
    this.wrapper.style.marginBottom = this.footer_height + "px";
};

Layout.prototype.setHeaderClearHeight = function () {
    this.header_height = this.header.getBoundingClientRect().height;
    // this.header_clear.style.height = this.header_height + "px";
    // this.wrapper.style.marginTop = this.header_height + "px";
};

Layout.prototype.initHeaderScrollListener = function () {
    var that = this,
        doc = document.documentElement,
        lastScroll = 0;

    window.addEventListener("scroll", function (e) {
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

        if (top > that.header_height / 2 && that.header.classList.contains('float')) {
            if (top < lastScroll) {
                that.header.classList.add("show");
                top++; // Fix for ie - trick that fixes showing/hiding on every scroll
            } else {
                that.header.classList.remove("show");
            }
        }

        lastScroll = top;
    }, false);
};

exports.default = Layout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _transitionend = __webpack_require__(16);

var _transitionend2 = _interopRequireDefault(_transitionend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Menu(opt) {

    var options = {
        button: '.menu-button',
        nav: '.js.nav',
        button_container: '.header__right'
    },
        obj = {},
        body = document.querySelector('body');

    if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) === "object") {
        extendDefaults(options, opt);
    }

    init();

    function init() {
        obj.menuButton = document.querySelector(options.button);
        if (obj.menuButton !== null) {
            obj.nav = document.querySelector(options.nav);
            if (obj.nav !== null) {
                obj.nav.addEventListener('click', function (e) {
                    e.stopPropagation();
                });
                obj.menuButton.addEventListener('click', button__click);
            }
        }

        var openWPmenuButton = document.querySelector('.wp-block-navigation__responsive-container-open');
        var closeWPmenuButton = document.querySelector('.wp-block-navigation__responsive-container-close');
        if (openWPmenuButton !== null && closeWPmenuButton !== null) {
            var rect = openWPmenuButton.getBoundingClientRect();
            var topPosition = rect.top + window.scrollY;
            var leftPosition = rect.left + window.scrollX;

            closeWPmenuButton.style.top = topPosition + "px";
            closeWPmenuButton.style.left = leftPosition + "px";
        }
    }

    function button__click(e) {
        e.stopPropagation();
        obj.menuButton.classList.toggle('is-menu-open');
        obj.nav.classList.toggle('is-open');
        body.classList.toggle('is-menu-open');

        obj.nav.addEventListener(_transitionend2.default, function () {
            document.addEventListener('click', body__click);
        });
    }

    function body__click(e) {
        obj.menuButton.classList.remove('is-menu-open');
        obj.nav.classList.remove('is-open');
        body.classList.remove('is-menu-open');

        document.removeEventListener('click', body__click);
    }

    function extendDefaults(src, prop) {
        var property;
        for (property in prop) {
            if (prop.hasOwnProperty(property)) {
                src[property] = prop[property];
            }
        }
    }
}

exports.default = Menu;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getParameter = __webpack_require__(4);

var _getParameter2 = _interopRequireDefault(_getParameter);

var _mixitup = __webpack_require__(68);

var _mixitup2 = _interopRequireDefault(_mixitup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components/product-filter

function ProductFilter(productContainerClass) {

    this.productClass = '.product';
    this.productContainerClass = productContainerClass;
    this.containers = document.querySelectorAll(this.productContainerClass);
    this.filterPrefix = '.product_cat-';
    this.queryParam = 'filter';
    this.instances = [];

    var that = this,
        slugs,
        classes,
        mixer,
        config = {
        animation: {
            effects: 'fade'
        },
        controls: {
            toggleLogic: 'or'
        },
        selectors: {
            target: this.productClass
        },
        callbacks: {
            onMixStart: function onMixStart(state, futureState) {
                console.log('onMixStart');
                that.handleEmptyMessage(futureState);
            },
            onMixEnd: function onMixEnd(state) {
                console.log('onMixEnd');
                that.updateUrl(state);
                jQuery('html, body').animate({
                    scrollTop: jQuery('.product-filter__container').offset().top - 100
                }, 500);
            }
        }
    };

    slugs = (0, _getParameter2.default)(this.queryParam);
    if (slugs) {
        classes = this.getClasses(slugs);
        config.load = {
            filter: classes
        };
    }

    for (var i = 0; i < this.containers.length; i++) {
        mixer = (0, _mixitup2.default)(this.containers[i], config);
        this.instances.push(mixer);
        this.handleEmptyMessage(mixer.getState());
    }
}

ProductFilter.prototype.updateUrl = function (state) {
    var slugs = this.getSlugs(state.activeFilter.selector);

    if (slugs != this.productClass) {
        window.history.pushState("object or string", document.title, location.pathname + "?" + this.queryParam + "=" + slugs);
    } else {
        window.history.pushState("object or string", document.title, location.pathname);
    }
};

ProductFilter.prototype.handleEmptyMessage = function (state) {
    var parentNode = state.container.parentNode;
    if (state.totalShow < 1) {
        // show empty message
        jQuery(parentNode.querySelector('.empty-message')).slideDown();
    } else {
        // hide empty message
        jQuery(parentNode.querySelector('.empty-message')).slideUp();
    }
};

ProductFilter.prototype.getSlugs = function (classString) {
    var slugs = classString.replaceAll(this.filterPrefix, "");
    slugs = slugs.split(", ");
    slugs.sort();
    slugs = slugs.join(",");
    return slugs;
};

ProductFilter.prototype.getClasses = function (slugs) {
    var classes = slugs.split(",");
    classes.sort();
    var classString = "";
    for (var i = 0; i < classes.length; i++) {
        classString += this.filterPrefix + classes[i];
        if (i != classes.length - 1) {
            classString += ", ";
        }
    }
    return classString;
};

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

exports.default = ProductFilter;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toggle = __webpack_require__(15);

var _toggle2 = _interopRequireDefault(_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Selectblock() {

    if (document.querySelector('.selectblock') !== null) {
        this.init();
    }
}

Selectblock.prototype.init = function () {

    var toggle = new _toggle2.default('.selectblock__header', '.selectblock ul', 'clicked', 'show', false, true),
        selectBlocks = document.querySelectorAll('.selectblock.js'),
        selectBlock;

    if (selectBlocks !== null) {
        for (var i = 0; i < selectBlocks.length; i++) {
            selectBlock = selectBlocks[i];
            this.list_width(selectBlock);
        }
    }
};

Selectblock.prototype.list_width = function (elem) {

    // get width of widest list item and set parent to that width

    if (window.innerWidth >= 600) {

        var lists = elem.querySelectorAll('ul li'),
            list,
            biggestWidth;

        if (lists !== null) {
            biggestWidth = 0;
            for (var i = 0; i < lists.length; i++) {

                list = lists[i];
                if (list.offsetWidth > biggestWidth) {
                    biggestWidth = list.offsetWidth;
                }
            }
            elem.style.width = biggestWidth + "px";
        }
    }
};

exports.default = Selectblock;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _menu = __webpack_require__(33);

var _menu2 = _interopRequireDefault(_menu);

var _flickity = __webpack_require__(3);

var _flickity2 = _interopRequireDefault(_flickity);

var _table = __webpack_require__(55);

var _table2 = _interopRequireDefault(_table);

var _overlay = __webpack_require__(14);

var _overlay2 = _interopRequireDefault(_overlay);

var _header = __webpack_require__(30);

var _header2 = _interopRequireDefault(_header);

var _layout = __webpack_require__(32);

var _layout2 = _interopRequireDefault(_layout);

var _fadeInItem = __webpack_require__(52);

var _fadeInItem2 = _interopRequireDefault(_fadeInItem);

var _moveit = __webpack_require__(54);

var _moveit2 = _interopRequireDefault(_moveit);

var _selectblock = __webpack_require__(35);

var _selectblock2 = _interopRequireDefault(_selectblock);

var _calendarReminder = __webpack_require__(21);

var _calendarReminder2 = _interopRequireDefault(_calendarReminder);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _utmTracking = __webpack_require__(7);

var _utmTracking2 = _interopRequireDefault(_utmTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(12);
__webpack_require__(72);

window.password_meets_min_reqs = function (value) {
    if (value.length < 6) {
        return false;
    }

    var reqs = /^.*(?=.{6,40})(?=.*\d)(?=.*[a-zA-Z]).*$/;

    if (value.match(reqs) != null) {
        return true;
    }

    return false;
};

window.checkPasswordStrength = function ($pass1, $strengthResult, blacklistArray, buttonToDisable, showHint) {
    // console.log('checkPasswordStrength');

    var pass1 = $pass1.val();
    var pass2 = null;

    // Reset the form & meter
    // $submitButton.attr( 'disabled', 'disabled' );
    $strengthResult.removeClass("short bad good strong");

    // Extend our blacklist array with those from the inputs & site data
    blacklistArray = blacklistArray.concat(wp.passwordStrength.userInputDisallowedList());

    // Get the password strength
    window.new_password_strength = wp.passwordStrength.meter(pass1, blacklistArray, pass2);

    // Add the strength meter results
    switch (window.new_password_strength) {
        case 2:
            $strengthResult.addClass("bad").html(pwsL10n.bad);
            break;

        case 3:
            $strengthResult.addClass("good").html(pwsL10n.good);
            break;

        case 4:
            $strengthResult.addClass("strong").html(pwsL10n.strong);
            break;

        case 5:
            $strengthResult.addClass("short").html(pwsL10n.mismatch);
            break;

        default:
            $strengthResult.addClass("short").html(pwsL10n.short);
    }

    if (window.password_meets_min_reqs(pass1) || window.new_password_strength > 2) {
        if (buttonToDisable) {
            // console.log('REENABLE BUTTON');
            buttonToDisable.prop("disabled", false);
        }
        if (showHint && jQuery("#password_hint").length) {
            // console.log('REMOVE PASSWORD HINT');
            jQuery("#password_hint").remove();
        }
        $pass1.parent("p").removeClass("woocommerce-invalid");
    } else {
        if (buttonToDisable) {
            // console.log('DISABLE BUTTON');
            buttonToDisable.prop("disabled", true);
        }
        if (showHint && !jQuery("#password_hint").length) {
            // console.log('ADD PASSWORD HINT');
            $strengthResult.after('<span id="password_hint" class="input-error-message">Please enter a stronger password (6 characters minimum, including letters and numbers)</span>');
        }
        $pass1.parent("p").addClass("woocommerce-invalid");
    }

    return;
};

function label_init() {
    "use strict";

    jQuery(".gform_body input, .gform_body textarea").on("focus", function () {
        var label = jQuery(this).parent().prev("label");
        jQuery(label).addClass("is-focus");
    });

    jQuery(".gform_body input, .gform_body textarea").on("blur", function () {
        var label = jQuery(this).parent().prev("label");
        if (jQuery(this).val() === "") {
            jQuery(label).removeClass("is-focus");
        }
    });
}

window.isElementInViewport = function (el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return rect.bottom >= 0 && rect.right >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) && rect.left <= (window.innerWidth || document.documentElement.clientWidth);
};

function checkCtaStyles() {
    var hide_cta = false,
        hide_cta_buttons = document.querySelectorAll(".hide-cta"),
        cta_button = document.querySelector(".footer .cta");

    if (hide_cta_buttons !== null) {
        for (var i = 0; i < hide_cta_buttons.length; i++) {
            if (isElementInViewport(hide_cta_buttons[i])) {
                if (!cta_button.classList.contains("fadeOut")) {
                    cta_button.classList.remove("fadeIn");
                    cta_button.classList.add("fadeOut");
                }
                hide_cta = true;
            }
        }

        if (!hide_cta) {
            if (!cta_button.classList.contains("fadeIn") || cta_button.classList.contains("hide")) {
                cta_button.classList.remove("fadeOut");
                cta_button.classList.remove("hide");
                cta_button.classList.add("fadeIn");
            }
        }
    }
}

exports.default = {
    init: function init() {
        // console.log(
        //     "==================================================================="
        // );
        // console.log(
        //     "Website designed and built by Giant Peach https://giantpeach.agency"
        // );
        // console.log(
        //     "==================================================================="
        // );

        var detectie = __webpack_require__(57),
            header = new _header2.default(),
            footer = "",
            menu = new _menu2.default(),
            newsletter_signup = "",
            selectblock = new _selectblock2.default();

        if (detectie() !== false) {
            document.documentElement.classList.add("ie");
            if (detectie() <= 11) {
                document.documentElement.classList.add("ie-lteq-11");
            }
        } else {
            document.documentElement.classList.add("no-ie");
        }

        function callback() {
            this.classList.add("is-visible");
        }
        new _calendarReminder2.default();

        var utm = new _utmTracking2.default();
        utm.storeData();
    },
    finalize: function finalize() {
        var banner,
            testimonials,
            table = new _table2.default(),
            overlays = document.querySelectorAll(".overlay"),
            overlay_id,
            overlay,
            layout = new _layout2.default(),
            fadeInItem = new _fadeInItem2.default(),
            moveit = new _moveit2.default(),
            hide_cta_buttons,
            cta_button = document.querySelector(".cta");

        if (document.querySelector(".banner.js .banner__container") !== null) {
            banner = new _flickity2.default(".banner.js .banner__container", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 4000,
                selectedAttraction: 0.1,
                friction: 1
            });
        }

        jQuery(window).on("load", function () {
            if (document.querySelector(".testimonials.js") !== null) {
                banner = new _flickity2.default(".testimonials.js", {
                    cellAlign: "left",
                    wrapAround: true,
                    autoPlay: 5000,
                    selectedAttraction: 0.1,
                    friction: 1.6,
                    prevNextButtons: false,
                    pageDots: true
                });
            }
        });

        if (overlays !== null) {
            for (var i = 0; i < overlays.length; i++) {
                overlay_id = overlays[i].id;
                overlay = new _overlay2.default({
                    trigger: document.querySelectorAll(".overlay__button--" + overlay_id)
                });
            }
        }

        label_init();
        window.label_init = label_init;

        hide_cta_buttons = document.querySelectorAll(".hide-cta");

        if (cta_button !== null && hide_cta_buttons.length > 0) {
            window.addEventListener("load", checkCtaStyles);
            window.addEventListener("scroll", (0, _lodash2.default)(checkCtaStyles, 10));
            window.addEventListener("resize", (0, _lodash2.default)(checkCtaStyles, 10));
        } else if (cta_button !== null) {
            cta_button.classList.remove("hide");
        }

        document.addEventListener("update-overlays", function () {
            var overlays = document.querySelectorAll(".overlay");

            if (overlays !== null) {
                for (var i = 0; i < overlays.length; i++) {
                    overlay_id = overlays[i].id;
                    overlay = new _overlay2.default({
                        trigger: document.querySelectorAll(".overlay__button--" + overlay_id)
                    });
                }
            }
        });

        jQuery(window).on("load", function () {
            if (document.querySelector(".products-testimonials-carousel") !== null) {
                banner = new _flickity2.default(".products-testimonials-carousel", {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    arrowShape: "M76.52,102.72c.98,1.01,2.6,1.04,3.61,.05,1.01-.98,1.04-2.6,.05-3.61L39.42,57.14,80.19,15.12c.98-1.01,.96-2.63-.05-3.61-1.01-.98-2.63-.96-3.61,.05L34.05,55.34c-.36,.36-.59,.81-.69,1.28-.09,.44-.07,.9,.07,1.33,.12,.37,.33,.71,.62,1l42.48,43.77Z",
                    autoPlay: false,
                    pageDots: false,
                    prevNextButtons: true
                });
            }
        });

        var product_faq_accordions = jQuery('.product-faq-accordion');
        if (product_faq_accordions.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var el = _step.value;

                    var product_faq_accordion = jQuery(el);
                    var product_faq_accordion_heading = product_faq_accordion.find('.heading');
                    var product_faq_accordion_content = product_faq_accordion.find('.content');

                    product_faq_accordion_heading.on('click', function () {
                        product_faq_accordion_heading.toggleClass('active');
                        product_faq_accordion_content.stop(false, false).slideToggle();
                    });
                };

                for (var _iterator = product_faq_accordions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        jQuery('body').on('click', '.smooth-scroll', function (e) {
            e.preventDefault();

            var href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top
            }, 300);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__(13);

var _tabs2 = _interopRequireDefault(_tabs);

var _flickity = __webpack_require__(3);

var _flickity2 = _interopRequireDefault(_flickity);

var _headlineRotate = __webpack_require__(31);

var _headlineRotate2 = _interopRequireDefault(_headlineRotate);

var _isAutoplaySupported = __webpack_require__(53);

var _isAutoplaySupported2 = _interopRequireDefault(_isAutoplaySupported);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {},
    finalize: function finalize() {

        var tabs = new _tabs2.default(),
            isChrome = !!window.chrome && !!window.chrome.webstore,
            player = document.getElementById('player');
        window.video_playing = false;

        if (player !== null) {
            player.addEventListener('playing', function () {
                console.log('playing');
                window.video_playing = true;
            });

            setTimeout(function () {
                (0, _isAutoplaySupported2.default)(function (supported) {
                    if (isChrome || window.video_playing || supported) {
                        console.log('autoplay is supported');
                        player.addEventListener('ended', function () {

                            setTimeout(function () {

                                var swipeEl = document.querySelector('.to-swipe');
                                var swipeInnerEl = document.querySelector('.to-swipe-inner');
                                if (swipeEl && swipeInnerEl) {
                                    swipeEl.classList.add('swipe');
                                    swipeEl.classList.add('swipe--in');
                                    swipeEl.classList.remove('to-swipe');

                                    swipeInnerEl.classList.add('swipe__inner');
                                    swipeInnerEl.classList.remove('to-swipe-inner');
                                }
                            }, 500);
                        }, false);
                    } else {
                        console.log('autoplay is supported, hide video');
                        document.querySelector('.banner__video').style.display = "none";

                        var swipeEl = document.querySelector('.to-swipe');
                        var swipeInnerEl = document.querySelector('.to-swipe-inner');
                        if (swipeEl && swipeInnerEl) {
                            swipeEl.classList.add('swipe');
                            swipeEl.classList.add('swipe--in');
                            swipeEl.classList.remove('to-swipe');

                            swipeInnerEl.classList.add('swipe__inner');
                            swipeInnerEl.classList.remove('to-swipe-inner');
                        }
                    }
                });
            }, 500);
        } else {
            setTimeout(function () {
                var swipeEl = document.querySelector('.to-swipe');
                var swipeInnerEl = document.querySelector('.to-swipe-inner');
                if (swipeEl && swipeInnerEl) {
                    swipeEl.classList.add('swipe');
                    swipeEl.classList.add('swipe--in');
                    swipeEl.classList.remove('to-swipe');

                    swipeInnerEl.classList.add('swipe__inner');
                    swipeInnerEl.classList.remove('to-swipe-inner');
                }
            }, 500);
        }

        tabs.autoPlay('home__tabs');

        // NUTRITIONIST LOAD

        var nutritionistImages = document.querySelectorAll('.nutritionist img');
        var nutritionistImgs = Array();
        var loaded = 0;

        for (var i = 0; i < nutritionistImages.length; i++) {
            nutritionistImgs.push(new Image());

            nutritionistImgs[i].onload = function (value) {
                return function () {
                    loaded++;

                    if (loaded >= nutritionistImages.length) {

                        var carousel = new _flickity2.default(".nutritionist__carousel", {
                            groupCells: true,
                            pageDots: false,
                            selectedAttraction: 0.1,
                            imagesLoaded: true,
                            friction: 1,
                            arrowShape: 'M 0,50 L 20,30 L 20,45 L 100,45 L 100,55 L 20,55 L 20,70 Z'
                        });

                        jQuery('.nutritionist').css('height', '100%');
                    }
                };
            }(i);

            nutritionistImgs[i].src = nutritionistImages[i].getAttribute("data-src");
        }

        jQuery(document).ready(function () {
            var headline = new _headlineRotate2.default(jQuery('.cd-headline'), 2500);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _consultation = __webpack_require__(23);

var _consultation2 = _interopRequireDefault(_consultation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var consultation = new _consultation2.default();
    },
    finalize: function finalize() {}
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _faq = __webpack_require__(29);

var _faq2 = _interopRequireDefault(_faq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var faq = new _faq2.default();
    },
    finalize: function finalize() {}
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _productFilter = __webpack_require__(34);

var _productFilter2 = _interopRequireDefault(_productFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    init: function init() {
        var filter = new _productFilter2.default('.products:not(.products-editing)');
    },
    finalize: function finalize() {
        jQuery('.back-to-list-top').click(function (event) {
            event.preventDefault();
            jQuery('html, body').animate({
                scrollTop: jQuery("#products-list").offset().top - 1
            }, 500);
            jQuery('html, body').animate({ // go down 1px to hide floaty header (bit of a hack)
                scrollTop: jQuery("#products-list").offset().top
            }, 1);
        });

        jQuery('body').on('click', 'a[href*="#"].button', function (event) {
            var href = jQuery(this).attr('href');
            var hash = href.substring(href.indexOf('#'));

            if (jQuery(hash).length === 0) {
                return;
            }

            event.preventDefault();

            jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top - 50
            }, 500);
        });

        var buy_your_pack_sticky = function buy_your_pack_sticky() {

            var products_editing = jQuery('.products__editing');
            if (products_editing.length) {

                var products_editing_items = jQuery('.products__editing-items');
                var buy_this_pack_el = jQuery('.buy-this-pack-sticky');
                if (products_editing_items.length && buy_this_pack_el.length) {
                    var current_scroll = jQuery(window).scrollTop();
                    var products_editing_items_offset = products_editing_items.offset().top - 200;

                    if (current_scroll > products_editing_items_offset) {
                        buy_this_pack_el.addClass('fixed');
                    } else {
                        buy_this_pack_el.removeClass('fixed');
                    }
                }

                jQuery(window).scroll(function () {
                    var products_editing_items = jQuery('.products__editing-items');
                    var buy_this_pack_el = jQuery('.buy-this-pack-sticky');
                    if (products_editing_items.length && buy_this_pack_el.length) {
                        var _current_scroll = jQuery(window).scrollTop();
                        var _products_editing_items_offset = products_editing_items.offset().top - 200;

                        if (_current_scroll > _products_editing_items_offset) {
                            buy_this_pack_el.addClass('fixed');
                        } else {
                            buy_this_pack_el.removeClass('fixed');
                        }
                    }
                });
            }
        };

        buy_your_pack_sticky();
        jQuery(window).resize(function () {
            buy_your_pack_sticky();
        });

        jQuery(document.body).on('wc_fragments_refreshed', function () {
            buy_your_pack_sticky();
        });

        load_from_consultation_handler();

        jQuery(document.body).on('wc_fragments_refreshed', function () {
            var product_descriptions = jQuery('.product__shortdescription');
            if (product_descriptions.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = product_descriptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var el = _step.value;

                        var product_description = jQuery(el);

                        product_description.removeClass('has-more-button show-all');
                        if (product_description.find('.show').length) {
                            product_description.find('.show').remove();
                        }

                        if (product_description.innerHeight() > 54) {
                            product_description.addClass('has-more-button');
                            product_description.append('<span class="show">... <span class="text">Read more</span></span>');
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });

        jQuery(window).resize(function () {
            var product_descriptions = jQuery('.product__shortdescription');
            if (product_descriptions.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = product_descriptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var el = _step2.value;

                        var product_description = jQuery(el);

                        product_description.removeClass('has-more-button show-all');
                        if (product_description.find('.show').length) {
                            product_description.find('.show').remove();
                        }

                        if (product_description.innerHeight() > 54) {
                            product_description.addClass('has-more-button');
                            product_description.append('<span class="show">... <span class="text">Read more</span></span>');
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        });

        jQuery(document.body).on('click', '.product__shortdescription .show', function () {
            jQuery(this).parent().addClass('show-all');
        });
    }
};

/** Set the cart hash in both session and local storage */

var set_cart_hash = function set_cart_hash(cart_hash, cart_hash_key, $supports_html5_storage) {
    if ($supports_html5_storage) {
        localStorage.setItem(cart_hash_key, cart_hash);
        sessionStorage.setItem(cart_hash_key, cart_hash);
    }
};

var set_cart_creation_timestamp = function set_cart_creation_timestamp($supports_html5_storage) {
    if ($supports_html5_storage) {
        sessionStorage.setItem('wc_cart_created', new Date().getTime());
    }
};

var load_from_consultation_handler = function load_from_consultation_handler() {
    if (typeof wc_cart_fragments_params === 'undefined') {
        return;
    }

    /* Storage Handling */
    var $supports_html5_storage = true,
        cart_hash_key = wc_cart_fragments_params.cart_hash_key;

    try {
        $supports_html5_storage = 'sessionStorage' in window && window.sessionStorage !== null;
        window.sessionStorage.setItem('wc', 'test');
        window.sessionStorage.removeItem('wc');
        window.localStorage.setItem('wc', 'test');
        window.localStorage.removeItem('wc');
    } catch (err) {
        $supports_html5_storage = false;
    }

    var $fragment_refresh = {
        url: wc_cart_fragments_params.wc_ajax_url.toString().replace('%%endpoint%%', 'get_refreshed_fragments'),
        type: 'POST',
        data: {
            time: new Date().getTime()
        },
        timeout: wc_cart_fragments_params.request_timeout,
        success: function success(data) {
            if (data && data.fragments) {

                jQuery.each(data.fragments, function (key, value) {
                    jQuery(key).replaceWith(value);
                });

                if ($supports_html5_storage) {
                    sessionStorage.setItem(wc_cart_fragments_params.fragment_name, JSON.stringify(data.fragments));
                    set_cart_hash(data.cart_hash, cart_hash_key, $supports_html5_storage);

                    if (data.cart_hash) {
                        set_cart_creation_timestamp($supports_html5_storage);
                    }
                }

                jQuery(document.body).trigger('wc_fragments_refreshed');
            }
        },
        error: function error() {
            jQuery(document.body).trigger('wc_fragments_ajax_error');
        }
    };

    jQuery(document.body).on('wc_fragments_refreshed', function () {
        var loaded_consultation_event = new CustomEvent("ew-loaded-consultation");
        document.dispatchEvent(loaded_consultation_event);
    });

    setTimeout(function () {
        if (typeof window.on_load_consultation_id !== 'undefined') {

            var loading_consultation_event = new CustomEvent("ew-loading-consultation");
            document.dispatchEvent(loading_consultation_event);

            jQuery.ajax({
                type: "POST",
                url: window.toCartUrl,
                data: { consultation_id: window.on_load_consultation_id }
            }).done(function (product_ids) {
                if (product_ids.length) {
                    jQuery('.products__group .product').removeClass('recommended');
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = product_ids[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var product_id = _step3.value;

                            jQuery('.products__group .product.post-' + product_id).addClass('recommended');
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }

                jQuery.ajax($fragment_refresh);
            });
        }
    });

    jQuery('body').on('click', '.load-from-consultation', function (e) {
        var button = jQuery(this);
        var consultation_id = button.data('consultation_id');

        button.addClass('loading');

        var loading_consultation_event = new CustomEvent("ew-loading-consultation");
        document.dispatchEvent(loading_consultation_event);

        jQuery.ajax({
            type: "POST",
            url: window.toCartUrl,
            data: { consultation_id: consultation_id }
        }).done(function (response) {
            jQuery.ajax($fragment_refresh);
            button.removeClass('loading');
        });
    });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabs = __webpack_require__(13);

var _tabs2 = _interopRequireDefault(_tabs);

var _flickity = __webpack_require__(3);

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Headline from "../components/headline-rotate";

exports.default = {
    init: function init() {},
    finalize: function finalize() {
        // var tabs = new Tabs();

        var bannerNode = document.querySelector('.banner--product');
        var bannerImgNode = bannerNode.querySelector('.banner__image img');
        var isPouch = false;
        var isGroup = false;
        if (document.querySelector('.cart.pouch_form')) isPouch = true;
        if (document.querySelector('.cart.grouped_form')) isGroup = true;

        bannerImgNode.addEventListener('load', function () {
            bannerNode.classList.add('loaded');
        });

        jQuery(document).ready(function () {
            // var headline = new Headline(jQuery('.cd-headline'),2500);
            bannerNode.classList.add('loaded');
        });

        // quantity control box
        var quantityControlBox = jQuery('.quantity-control-box');
        if (quantityControlBox.length > 0) {
            var currentQty = Number(jQuery('.cart .quantity input.qty').val());

            quantityControlBox.find('button').on('click', function (e) {
                var btnAction = $(this).data('action');
                switch (btnAction) {
                    case 'add':
                        {
                            currentQty += 1;
                        }break;
                    case 'subtract':
                        {
                            if (currentQty > 1) {
                                currentQty -= 1;
                            }
                        }break;
                }

                if (currentQty > 1) {
                    quantityControlBox.find('.subtract-qty').removeClass('disabled');
                } else {
                    quantityControlBox.find('.subtract-qty').addClass('disabled');
                }

                jQuery('.cart .quantity input.qty').attr('value', currentQty);
                jQuery('.cart .qtyCounter').text(currentQty);
            });

            if (currentQty == 1) {
                quantityControlBox.find('.subtract-qty').addClass('disabled');
            }
        }

        // make add to cart ajax
        jQuery('.summary .single_add_to_cart_button, .footer .cta .single_add_to_cart_button').click(function (event) {

            var $thisbutton = jQuery(this);
            event.preventDefault();

            var summary_button = jQuery('.summary .single_add_to_cart_button');
            var cta_button = jQuery('.footer .cta .single_add_to_cart_button');

            cta_button.addClass('waiting');
            summary_button.addClass('waiting');

            var data = {};
            jQuery.each(jQuery('form.cart').serializeArray(), function () {
                data[this.name] = this.value;
            });
            data.product_id = jQuery('.cart input[name=add-to-cart]').val();
            data.quantity = jQuery('.cart input[name=quantity]').val();

            // pouches can have multiple quantity. add-to-cart param adds +2 to quantity!
            var $thisbuttonform = $thisbutton.parents('.pouch_form');
            console.log($thisbutton);
            if ($thisbuttonform.length > 0 || $thisbutton.hasClass('add_to_cart_pouch')) {
                delete data['add-to-cart'];
            }

            jQuery.ajax({
                type: "POST",
                url: window.ajaxUrl,
                data: data
            }).done(function (response) {

                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

                if (typeof response.error == "undefined") {

                    if (isGroup || isPouch) {
                        window.location = window.cartUrl;
                        return;
                    }

                    cta_button.removeClass('waiting');
                    summary_button.removeClass('waiting');

                    var summary_html = '<a href="' + window.cartUrl + '" class="added_to_cart wc-forward button button--transparent button--lg" title="View pack">';
                    summary_html += 'View pack';
                    summary_html += '</a>';
                    summary_button.hide();
                    summary_button.parent('.product__add-container').append(summary_html);

                    var cta_html = '<a href="' + window.cartUrl + '" class="added_to_cart_cta wc-forward button" title="View pack">';
                    cta_html += 'View pack';
                    cta_html += '</a>';
                    cta_button.replaceWith(cta_html);

                    if (typeof response.fragments != "undefined") {
                        for (var selector in response.fragments) {
                            jQuery(selector).replaceWith(response.fragments[selector]);
                        }
                        jQuery(document.body).trigger('wc_fragments_refreshed');
                    }
                } else {
                    cta_button.removeClass('waiting');
                    summary_button.removeClass('waiting');
                    alert('An error occured while adding to pack. Please refresh the page and try again');
                }
            });
        });

        jQuery('.product__key-fact-heading').click(function () {
            jQuery(this).toggleClass('clicked');
            jQuery(this).siblings('.product__key-fact-text').slideToggle();
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.default = {
        init: function init() {},
        finalize: function finalize() {

                if (window.innerWidth >= 1024) {
                        document.querySelector('.woocommerce-MyAccount-navigation-link').classList.add('is-active');
                }

                jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

                jQuery("#password_1").keyup(function (e) {

                        window.checkPasswordStrength(jQuery(this), jQuery('#password_strength'), [], jQuery('form.edit-account button'), true);
                });
        }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    init: function init() {},
    finalize: function finalize() {

        jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#password_1").keyup(function (e) {

            window.checkPasswordStrength(jQuery(this), jQuery('#password_strength'), [], jQuery('form.edit-account button'), true);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    init: function init() {},
    finalize: function finalize() {

        jQuery('#password_1').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#password_1").keyup(function (e) {

            window.checkPasswordStrength(jQuery(this), jQuery('#password_strength'), [], jQuery('form.lost_reset_password button'), true);
        });

        jQuery.ajax({
            url: ew.wc_ajax_url.toString().replace('%%endpoint%%', 'ew_create_pass_reset_nonce'),
            type: 'POST',
            data: {},
            success: function success(response) {
                jQuery('input[name="woocommerce-lost-password-nonce"]').val(response);
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
__webpack_require__(69);

exports.default = {
    init: function init() {},
    finalize: function finalize() {

        var sticky_sidebar = new Sticksy('.results-pack-card');
        if (jQuery(window).width() >= 1024) {
            sticky_sidebar.enable();
        } else {
            sticky_sidebar.disable();
        }

        jQuery(window).on('resize', function () {
            if (jQuery(window).width() >= 1024) {
                sticky_sidebar.enable();
            } else {
                sticky_sidebar.disable();
            }
        });

        jQuery('.results-faq-item-question').click(function () {
            jQuery(this).siblings('.results-faq-item-answer').stop().slideToggle();
            jQuery(this).parent('.results-faq-item').toggleClass('open');
        });

        jQuery('.results__learn-more').click(function () {
            jQuery(this).siblings('.results__read-more').slideDown();
            jQuery(this).remove();
        });

        // make add to cart ajax
        jQuery('.pack_add_to_cart_button').click(function (event) {
            event.preventDefault();

            jQuery('.pack_add_to_cart_button').addClass('waiting');

            jQuery.ajax({
                type: "POST",
                url: window.addUrl,
                data: { consultation_products: window.consultation_products, consultation_id: window.consultation_id }
            }).done(function () {
                window.location = window.checkoutUrl;
                jQuery('.pack_add_to_cart_button').removeClass('waiting');
                jQuery('.pack_add_to_cart_button').addClass('disabled');
            });
        });

        jQuery('.ingredients-link a').click(function (e) {
            e.preventDefault();

            var href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top
            }, 300);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

Object.defineProperty(exports, "__esModule", {
            value: true
});
exports.default = {
            init: function init() {},
            finalize: function finalize() {
                        // var form = document.getElementById('cancel-subscription');
                        // if (form !== null) {
                        //     form.addEventListener('submit', function (event) {
                        //         console.log('form submit listener');

                        //         event.preventDefault();

                        //         if (form.classList.contains('waiting')) {
                        //             return;
                        //         }

                        //         var button = form.querySelector('button[type="submit"]');
                        //         var input = form.querySelector('.input');
                        //         var message = input.querySelector('textarea');
                        //         var error_message = input.querySelector('.input-message');
                        //         var cancel_url = form.querySelector('[name=cancel_url]').value;

                        //         if (message.value.length < 10) {
                        //             input.classList.add('is-error');
                        //             error_message.innerHTML = "Please enter a longer reason.";
                        //         }
                        //         else {
                        //             button.classList.add('waiting');
                        //             form.classList.add('waiting');

                        //             var form_data = jQuery(this).serialize();

                        //             jQuery.ajax({
                        //                 type: "POST",
                        //                 url: "/wp-json/gp_forms/v1/submit/cancel-subscription?_wpnonce=" + nonce[1],
                        //                 data: form_data
                        //             }).done(function (response) {
                        //                 if (response.hasErrors !== false) {
                        //                     error_message.innerHTML = "An error occured. Please contact us for assistance.";
                        //                 }
                        //                 else {
                        //                     window.location.href = cancel_url;
                        //                 }
                        //             });

                        //         }


                        //     });
                        // }

                        /** Reset cancellation process on modal close */
                        jQuery('.overlay__close').on('click', function (e) {
                                    jQuery('.form-cancel-subscription-laststep').hide();
                                    jQuery('.form--cancel-subscription-container > div').hide();
                                    jQuery('.cancel-subscription-list-container').show();
                        });

                        function addParameterToURL(param) {
                                    var _url = location.href;
                                    _url += (_url.split('?')[1] ? '&' : '?') + param;
                                    return _url;
                        }

                        function parseQuery(queryString) {
                                    var query = {};
                                    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
                                    for (var i = 0; i < pairs.length; i++) {
                                                var pair = pairs[i].split('=');
                                                query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
                                    }
                                    return query;
                        }

                        function cancelModalRedirect() {
                                    var feedback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

                                    console.log('cancelModalRedirect');

                                    var container = jQuery('.overlay-cancel-subscription');
                                    var cancel = container.find('input[name=cancel]').val();

                                    var reason = jQuery('.overlay-cancel-subscription input[name=reason]').val();

                                    var pauseLink = container.find('input[name=actionlink]').val();
                                    var pauseLinkObject = parseQuery(pauseLink);

                                    // customer.io data
                                    var willCancel = cancel == 1 ? true : false;
                                    var data = {
                                                reason: reason,
                                                cancelled: willCancel ? 'yes' : 'no',
                                                user_id: jQuery('.overlay-cancel-subscription').data('userid')
                                    };

                                    switch (reason) {
                                                case 'forgotToTake':
                                                case 'tooMany':
                                                            {
                                                                        if (!willCancel) {
                                                                                    data.paused = pauseLinkObject.pause_subscription;
                                                                        }
                                                            }break;
                                                case 'notHappy':
                                                case 'other':
                                                            {
                                                                        data.feedback = feedback;
                                                                        data.cancelled = 'yes';
                                                            }break;
                                                case 'tooExpensive':
                                                            {
                                                                        if (!willCancel) {
                                                                                    var discountCode = jQuery('.overlay-cancel-subscription input[name=discountcode]').val();
                                                                                    data.discount = discountCode;
                                                                        }
                                                            }break;
                                                case 'needTime':
                                                            {
                                                                        if (!willCancel) {
                                                                                    if (cancel == 4) {
                                                                                                data.action = 'stay_subscribed';
                                                                                    } else {
                                                                                                data.paused = pauseLinkObject.pause_subscription;
                                                                                    }
                                                                        }
                                                            }break;
                                    }

                                    data.subscription_id = window.cancellation_subscription_id;

                                    console.log(data);

                                    jQuery.ajax({
                                                type: "POST",
                                                url: "/wp-json/q/v1/cancellation/submit",
                                                data: data,
                                                beforeSend: function beforeSend(xhr) {
                                                            xhr.setRequestHeader('X-WP-Nonce', nonce[1]);
                                                }
                                    }).done(function (response) {

                                                console.log({ cancel: cancel });

                                                if (cancel == 0) {
                                                            var pauseLink = container.find('input[name=actionlink]').val();
                                                            var pauseLinkComplete = window.location.href + pauseLink;
                                                            console.log('redirect', pauseLinkComplete);
                                                            window.location.replace(pauseLinkComplete);
                                                } else if (cancel == 1) {
                                                            var cancelLink = container.find('input[name=cancellink]').val();
                                                            console.log('redirect', cancelLink);
                                                            window.location.href = cancelLink;
                                                } else if (cancel == 3) {
                                                            var discountLink = jQuery('.overlay-cancel-subscription input[name=discountlink]').val();
                                                            console.log('redirect', discountLink);
                                                            window.location.href = discountLink;
                                                } else if (cancel == 4) {
                                                            var reloadUrl = addParameterToURL('cancelsubscription=false');
                                                            console.log('redirect', reloadUrl);
                                                            window.location.href = reloadUrl;
                                                }
                                    });
                        }

                        jQuery('#cancel-subscription textarea').keyup(function () {

                                    if (jQuery(this).val().length >= 10) {
                                                jQuery('#cancel-subscription .input').removeClass('is-error');
                                                jQuery('#cancel-subscription .input-message').empty();
                                    }
                        });

                        // attach checked class 
                        jQuery('.cancel-subscription-list-form input[type=radio]').on('click', function (e) {
                                    var radioButtons = jQuery('.cancel-subscription-list-form input[type=radio]');
                                    radioButtons.each(function (i, item) {
                                                var isChecked = jQuery(item).is(':checked');
                                                if (isChecked) {
                                                            jQuery(item).parents('.radio-cancel-subscription').addClass('checked');
                                                } else {
                                                            jQuery(item).parents('.radio-cancel-subscription').removeClass('checked');
                                                }
                                    });
                        });

                        // THIS FIRST??
                        jQuery('.cancel-subscription-list-form').on('submit', function (e) {

                                    console.log('cancel-subscription-list-form form submit');
                                    e.preventDefault();

                                    var $form = jQuery(this);
                                    var selectedReason = $form.find('.cancel-subscription-list input[name=cancelreason]:checked').val();

                                    // show the form for the selected reason
                                    if (selectedReason) {

                                                $form.find('.is-error-text').css('visibility', 'hidden');
                                                var selectedBlockSelector = '.form--cancel-subscription-container' + ' .' + selectedReason;
                                                jQuery('.overlay-cancel-subscription input[name=reason]').val(selectedReason);

                                                // scroll to top 
                                                document.getElementById('overlay_maincontent').scrollTop = 0;

                                                jQuery('.cancel-subscription-list-container').fadeOut(400, function () {
                                                            jQuery(selectedBlockSelector).fadeIn();
                                                });
                                    } else {

                                                $form.find('.is-error-text').css('visibility', 'visible');
                                                var overlayContainer = document.getElementById('overlay_maincontent');
                                                overlayContainer.scrollTop = overlayContainer.scrollHeight - overlayContainer.clientHeight;
                                    }
                        });

                        // forgotToTake
                        jQuery('.forgotToTake .pause_subscription').on('click', function (e) {

                                    e.preventDefault();

                                    var pauseLink = $(this).data('pauselink');

                                    jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--stay').show();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        jQuery('.forgotToTake .form-subscription-cancel-link').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        // tooMany
                        jQuery('.tooMany .pause_subscription').on('click', function (e) {

                                    e.preventDefault();

                                    var pauseLink = $(this).data('pauselink');

                                    jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--stay').show();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        jQuery('.tooMany .form-subscription-cancel-link').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        // notHappy
                        jQuery('.notHappy form').on('submit', function (e) {

                                    e.preventDefault();
                                    var cancelFeedback = jQuery(this).find('.cancelfeedback').val();

                                    if (cancelFeedback.length < 10) {
                                                jQuery(this).find('.input').addClass('is-error');
                                                jQuery(this).find('.input-message').text('Please enter a longer reason.');
                                    } else {

                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form--cancel-subscription-container').hide();
                                                jQuery(this).find('button').addClass('waiting');

                                                jQuery(this).find('.input').removeClass('is-error');
                                                jQuery(this).find('.input-message').text('');

                                                // jQuery(this).find('button').addClass('waiting');

                                                jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                                // save feedback 
                                                cancelModalRedirect(cancelFeedback);
                                    }
                        });

                        // tooExpensive
                        jQuery('.tooExpensive .apply-discount').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('3');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--stay').show();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        jQuery('.tooExpensive .form-subscription-cancel-link').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        // needTime
                        jQuery('.needTime .stay-subscribed').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('4');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--stay').show();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        jQuery('.needTime .form-subscription-cancel-link').on('click', function (e) {

                                    e.preventDefault();

                                    jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        jQuery('.needTime .pause_subscription').on('click', function (e) {

                                    e.preventDefault();

                                    var pauseLink = $(this).data('pauselink');

                                    jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

                                    jQuery('.form--cancel-subscription-container').fadeOut(400, function () {
                                                jQuery('.form-cancel-subscription-laststep--stay').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                cancelModalRedirect();
                                    });
                        });

                        // other
                        jQuery('.other form').on('submit', function (e) {

                                    e.preventDefault();
                                    var cancelFeedback = jQuery(this).find('.cancelfeedback').val();

                                    if (cancelFeedback.length < 10) {
                                                jQuery(this).find('.input').addClass('is-error');
                                                jQuery(this).find('.input-message').text('Please enter a longer reason.');
                                    } else {
                                                jQuery(this).find('.input').removeClass('is-error');
                                                jQuery(this).find('.input-message').text('');

                                                jQuery(this).find('button').addClass('waiting');

                                                jQuery('.form-cancel-subscription-laststep--cancel').show();
                                                jQuery('.form-cancel-subscription-laststep').fadeIn();
                                                jQuery('#overlay_maincontent .h3').hide();
                                                jQuery('.form--cancel-subscription-container').hide();

                                                jQuery(this).find('.input').removeClass('is-error');
                                                jQuery(this).find('.input-message').text('');

                                                jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                                                cancelModalRedirect(cancelFeedback);
                                    }
                        });
            }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(0)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toggle = __webpack_require__(15);

var _toggle2 = _interopRequireDefault(_toggle);

var _flickity = __webpack_require__(3);

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(12);

exports.default = {
    init: function init() {},
    finalize: function finalize() {
        var toggle = new _toggle2.default('.myaccount__nav-select', '.myaccount__nav-options', 'clicked', 'open');
        var close_toggle = new _toggle2.default('.myaccount__nav-close', '.myaccount__nav-options', null, 'open');
        var login_form_wrapper = document.getElementById('customer_login');

        var scores = document.querySelectorAll('.radial-container');
        if (scores !== null) {
            for (var i = 0; i < scores.length; i++) {
                var percent = scores[i].dataset.progressFinish;
                scores[i].dataset.progress = percent;
            }
        }

        if (document.querySelector('.results-testimonials-carousel') !== null) {

            new _flickity2.default(".results-testimonials-carousel", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 3000,
                selectedAttraction: 0.1,
                friction: 1,
                prevNextButtons: true,
                pageDots: false
            });
        }

        jQuery('.myaccount__login-header li').click(function () {
            var $this = jQuery(this);

            if (!$this.hasClass('active')) {
                $this.siblings().removeClass('active');
                $this.addClass('active');

                if (login_form_wrapper) {
                    if (login_form_wrapper.classList.contains('show-register')) {
                        console.log('remove show-register');
                        login_form_wrapper.classList.remove('show-register');
                    } else {
                        console.log('add show-register');
                        login_form_wrapper.classList.add('show-register');
                    }
                }
            }
        });

        jQuery('body').on('click', 'a[href*="#"].scroll-to-link', function (event) {
            var href = jQuery(this).attr('href');
            var hash = href.substring(href.indexOf('#'));

            if (jQuery(hash).length === 0) {
                return;
            }

            event.preventDefault();

            jQuery('html, body').animate({
                scrollTop: jQuery(hash).offset().top - 50
            }, 500);
        });

        jQuery('#reg_password').after("<span id='password_strength' class='woocommerce-password-strength'></span>");

        jQuery("#reg_password").keyup(function (e) {

            window.checkPasswordStrength(jQuery(this), jQuery('#password_strength'), [], jQuery('form.register button'), true);
        });

        // report add to cart ajax
        jQuery('body').on('click', '.report_add_to_cart_button', function (e) {
            e.preventDefault();

            var loading_consultation_event = new CustomEvent("ew-loading-consultation");
            document.dispatchEvent(loading_consultation_event);

            jQuery.ajax({
                type: "POST",
                url: window.addUrl,
                data: { consultation_products: window.consultation_products, consultation_id: window.consultation_id }
            }).done(function () {
                window.location = window.checkoutUrl;
            });
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debounce = __webpack_require__(5);

var _debounce2 = _interopRequireDefault(_debounce);

var _flickity = __webpack_require__(3);

var _flickity2 = _interopRequireDefault(_flickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(12);

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

exports.default = {
    init: function init() {},
    finalize: function finalize() {

        if (document.querySelector('.results-testimonials-carousel') !== null) {

            new _flickity2.default(".results-testimonials-carousel", {
                cellAlign: "left",
                wrapAround: true,
                autoPlay: 3000,
                selectedAttraction: 0.1,
                friction: 1,
                prevNextButtons: true,
                pageDots: false
            });
        }

        var sticky_sidebar_el = jQuery('.results-pack-card');
        if (sticky_sidebar_el.length) {
            var sticky_sidebar = new Sticksy('.results-pack-card');
            if (jQuery(window).width() >= 1024) {
                sticky_sidebar.enable();
            } else {
                sticky_sidebar.disable();
            }

            jQuery(window).on('resize', function () {
                if (jQuery(window).width() >= 1024) {
                    sticky_sidebar.enable();
                } else {
                    sticky_sidebar.disable();
                }
            });
        }

        jQuery('.results-faq-item-question').click(function () {
            jQuery(this).siblings('.results-faq-item-answer').stop().slideToggle();
            jQuery(this).parent('.results-faq-item').toggleClass('open');
        });

        jQuery('.results__learn-more').click(function () {
            jQuery(this).siblings('.results__read-more').slideDown();
            jQuery(this).remove();
        });

        jQuery('.ingredients-link a').click(function (e) {
            e.preventDefault();

            var href = jQuery(this).attr('href');
            jQuery('html, body').animate({
                scrollTop: jQuery(href).offset().top - 80
            }, 300);
        });

        jQuery(document).on("click", ".cart__choice", function (event) {
            if (!jQuery(this).hasClass("cart__choice--selected")) {
                var choice = jQuery(this).attr("data-value");

                jQuery(this).addClass("clicked");

                jQuery("[name='cart_type']").val(choice);
                update_cart();
            }
        });

        jQuery(document).on("change", "input.qty", (0, _debounce2.default)(update_cart, 300));

        function update_cart() {
            jQuery("[name='update_cart']").removeAttr("disabled");
            jQuery("[name='update_cart']").trigger("click");
        }

        jQuery(document).on("click", "results__learn-more", function (event) {
            console.log("results click");
            console.log(jQuery(this));
            jQuery(this).siblings(".results__read-more").slideDown();
            jQuery(this).remove();
        });

        document.addEventListener("click", function (event) {
            var el = event.target;
            if (el.classList.contains("results__learn-more")) {
                jQuery(event.target).siblings(".results__read-more").slideDown();
                jQuery(event.target).remove();
            }
            if (el.classList.contains("subscribe-3-tooltip-inner") || el.classList.contains("subscribe-3-tooltip-icon")) {
                jQuery(".subscribe-3-tooltip").toggleClass("show-tooltip");
            }
        });
        // remove coupon cookie if Remove clicked on coupon
        document.addEventListener("click", function (event) {
            var el = event.target;
            if (el.classList.contains("woocommerce-remove-coupon")) {
                console.log("click remove coupon");
                event.preventDefault();
                var coupon = el.dataset.coupon;
                console.log("coupon", coupon);
                var cookie = getCookie("gp_coupon_from_url");
                cookie = decodeURIComponent(cookie);
                cookie = cookie.split("+").join(" ");
                console.log("cookie", cookie);
                if (cookie.toUpperCase() == coupon.toUpperCase()) {
                    console.log("remove coupon!");
                    document.cookie = "gp_coupon_from_url" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                }
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkoutNav = __webpack_require__(22);

var _checkoutNav2 = _interopRequireDefault(_checkoutNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

exports.default = {
    init: function init() {
        var checkout_nav = new _checkoutNav2.default();
    },
    finalize: function finalize() {
        // remove coupon cookie if Remove clicked
        document.addEventListener("click", function (event) {
            var el = event.target;
            if (el.classList.contains("woocommerce-remove-coupon")) {
                event.preventDefault();
                var coupon = el.dataset.coupon;
                var cookie = getCookie("gp_coupon_from_url");
                cookie = decodeURIComponent(cookie);
                cookie = cookie.split("+").join(" ");
                if (cookie.toUpperCase() == coupon.toUpperCase()) {
                    document.cookie = "gp_coupon_from_url" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                }
            }
        });

        // coupon mask functionality
        jQuery('body').on('input', 'input[name="coupon_code_mask"]', function () {
            jQuery('input[name="coupon_code"]').val(jQuery(this).val());
        });

        jQuery('body').on('click', '.apply_coupon_mask', function () {
            jQuery('button[name="apply_coupon"]').click();
            jQuery('input[name="coupon_code_mask"]').val('');
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* ========================================================================
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DOM-based Routing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Based on http://goo.gl/EUTi53 by Paul Irish
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Only fires on body classes that match. If a body class contains a dash,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * replace the dash with an underscore when adding it to the object below.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ======================================================================== */

var _camelCase = __webpack_require__(51);

var _camelCase2 = _interopRequireDefault(_camelCase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var Router = function () {
  function Router(routes) {
    _classCallCheck(this, Router);

    this.routes = routes;
  }

  _createClass(Router, [{
    key: 'fire',
    value: function fire(route) {
      var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'init';
      var args = arguments[2];

      var fire = route !== '' && this.routes[route] && typeof this.routes[route][fn] === 'function';
      if (fire) {
        this.routes[route][fn](args);
      }
    }
  }, {
    key: 'loadEvents',
    value: function loadEvents() {
      var _this = this;

      // Fire common init JS
      this.fire('common');

      // Fire page-specific init JS, and then finalize JS
      document.body.className.toLowerCase().replace(/-/g, '_').split(/\s+/).map(_camelCase2.default).forEach(function (className) {
        _this.fire(className);
        _this.fire(className, 'finalize');
      });

      // Fire common finalize JS
      this.fire('common', 'finalize');
    }
  }]);

  return Router;
}();

exports.default = Router;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// the most terrible camelizer on the internet, guaranteed!
exports.default = function (str) {
  return '' + str.charAt(0).toLowerCase() + str.replace(/[\W_]/g, '|').split('|').map(function (part) {
    return '' + part.charAt(0).toUpperCase() + part.slice(1);
  }).join('').slice(1);
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extendDefaults = __webpack_require__(17);

var _extendDefaults2 = _interopRequireDefault(_extendDefaults);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function fadeinItemLoad(opt) {

    jQuery(document).ready(function () {

        var that = this;

        var instances = [],
            elements,
            i = 0;

        this.options = {
            selector: ".fadeInItem"
        };

        if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) === "object") {
            (0, _extendDefaults2.default)(this.options, opt);
        }

        elements = document.querySelectorAll(this.options.selector);

        for (i = 0; i < elements.length; i++) {
            if (getStyle(elements[i], 'display') != "none") {
                instances.push(new fadeinItem(elements[i]));
            }
        }
    });
}

function fadeinItem(el) {

    this.el = el;

    this.style = window.getComputedStyle(el);
    this.delay = parseFloat(this.el.getAttribute("data-fadein-delay"));
    this.classes = this.el.getAttribute("data-fadein-classes");
    this.control = this.el.getAttribute("data-fadein-control");
    this.rect = el.getBoundingClientRect();

    this.class_applied = false;
    this.class_waiting = false;

    this.scroller = window;

    if (!this.control) {
        this.control = "self";
    }

    if (!this.classes) {
        this.classes = ["fadeIn"];
    } else {
        this.classes = this.el.getAttribute("data-fadein-classes").split(" ");
    }

    if (!this.delay) {
        this.delay = 0;
    }

    this.window = {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        scrollX: getBodyScrollX(),
        scrollY: getBodyScrollY(),
        scrollCenterX: getBodyScrollX() + window.innerWidth / 2,
        scrollCenterY: getBodyScrollY() + window.innerHeight / 2
    };

    if (this.scroller == window) {
        this.scroller = this.window;
        this.scroller.el = window;
    } else {}
    // TODO: handle other scroller elements.


    /* Position of moveit element */

    this.position = {
        top: this.rect.top + this.window.scrollY,
        left: this.rect.left + this.window.scrollX,
        x: getPosition(this.el).x,
        y: getPosition(this.el).y,
        offsetHeight: this.el.offsetHeight,
        offsetWidth: this.el.offsetWidth,
        translateX: 0,
        translateY: 0
    };
    this.position.centerY = this.position.top + this.position.offsetHeight / 2;
    this.position.centerX = this.position.left + this.position.offsetWidth / 2;

    if (this.style.getPropertyValue("transform") != "none" && this.style.getPropertyValue("transform") != null) {
        var transformMatrix = this.style.getPropertyValue("transform").split(",");
        this.position.translateX = parseFloat(transformMatrix[4]);
        this.position.translateY = parseFloat(transformMatrix[5].slice(0, -1));
    }

    /* Position of control element (when this element is in the center of the screen, the moveit element should be in its normal position) */

    if (this.control == "parent" || this.control == "parentNode") {
        var controlEl = this.el.parentNode;
        var controlRect = controlEl.getBoundingClientRect();
        this.controlPosition = {
            top: controlRect.top + this.window.scrollY,
            left: controlRect.left + this.window.scrollX,
            x: getPosition(controlEl).x,
            y: getPosition(controlEl).y,
            offsetHeight: controlEl.offsetHeight,
            offsetWidth: controlEl.offsetWidth
        };
        this.controlPosition.centerY = this.controlPosition.top + this.controlPosition.offsetHeight / 2;
        this.controlPosition.centerX = this.controlPosition.left + this.controlPosition.offsetWidth / 2;
    } else {
        // control is element itself
        this.controlPosition = this.position;
    }

    var that = this;

    // console.log(this.window);
    // console.log('speed');
    // console.log(this.speed);
    // console.log('mode');
    // console.log(this.mode);
    // console.log('control');
    // console.log(this.control);
    // console.log('direction');
    // console.log(this.direction);
    // console.log('position');
    // console.log(this.position);
    // console.log('controlPosition');
    // console.log(this.controlPosition);

    that.checkItem();

    this.scroller.el.addEventListener('scroll', function () {
        that.checkItem();
    });
}

fadeinItem.prototype.checkItem = function () {

    var that = this;
    if (that.class_applied || that.class_waiting) return;

    if (that.scroller.el == window) {
        // that.scroller.scrollX = getBodyScrollX();
        // that.scroller.scrollY = getBodyScrollY();
        // that.scroller.scrollCenterX = getBodyScrollX() + (window.innerWidth / 2);
        // that.scroller.scrollCenterY =  getBodyScrollY() + (window.innerHeight / 2);
        that.scroller.scrollThresholdX = getBodyScrollX() + window.innerWidth;
        that.scroller.scrollThresholdY = getBodyScrollY() + window.innerHeight;
    } else {}
    // TODO


    // console.log('scroller.scrollCenterX',that.scroller.scrollCenterY);
    // console.log('that.position.top',that.controlPosition.top);

    if (that.scroller.scrollThresholdY >= that.controlPosition.top) {
        if (!that.class_waiting && !that.class_applied) {
            if (that.delay) {
                that.class_waiting = true;
                setTimeout(function () {
                    that.applyClass(that);
                }, that.delay);
            } else {
                that.applyClass(that);
            }
        }
    }
};

fadeinItem.prototype.applyClass = function (that) {
    var _that$el$classList;

    that.class_waiting = false;
    that.class_applied = true;

    (_that$el$classList = that.el.classList).add.apply(_that$el$classList, _toConsumableArray(that.classes));
};

function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;

    while (element) {
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}

function getStyle(element, name) {
    return element.currentStyle ? element.currentStyle[name] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(name) : null;
}

function getBodyScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function getBodyScrollX() {
    return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
}

function getElementScrollY(el) {
    return el.getBoundingClientRect().top + getBodyScrollY();
}

function getElementScrollX(el) {
    return el.getBoundingClientRect().left + getBodyScrollX();
}

exports.default = fadeinItemLoad;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAutoplaySupported = function isAutoplaySupported(callback) {
  var timeout;
  var waitTime = 200;
  var retries = 5;
  var currentTry = 0;
  var elem = document.createElement('video');
  var elemStyle = elem.style;

  function testAutoplay(arg) {
    currentTry++;
    clearTimeout(timeout);

    var result = arg && arg.type === 'playing' || elem.currentTime !== 0;

    if (!result && currentTry < retries) {
      //Detection can be flaky if the browser is slow, so lets retry in a little bit
      timeout = setTimeout(testAutoplay, waitTime);
      return;
    }

    elem.removeEventListener('playing', testAutoplay, false);
    callback(result);

    // Cleanup, but don't assume elem is still in the page -
    // an extension (eg Flashblock) may already have removed it.
    if (elem.parentNode) {
      elem.parentNode.removeChild(elem);
    }
  }

  //skip the test if video itself, or the autoplay
  //element on it isn't supported
  if (!(elem.canPlayType && elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '')) || !('autoplay' in elem)) {
    callback(false);
    return;
  }

  elemStyle.position = 'absolute';
  elemStyle.height = 0;
  elemStyle.width = 0;

  try {
    elem.src = 'data:video/mp4;base64,AAAAFGZ0eXBNU05WAAACAE1TTlYAAAOUbW9vdgAAAGxtdmhkAAAAAM9ghv7PYIb+AAACWAAACu8AAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAnh0cmFrAAAAXHRraGQAAAAHz2CG/s9ghv4AAAABAAAAAAAACu8AAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAFAAAAA4AAAAAAHgbWRpYQAAACBtZGhkAAAAAM9ghv7PYIb+AAALuAAANq8AAAAAAAAAIWhkbHIAAAAAbWhscnZpZGVBVlMgAAAAAAABAB4AAAABl21pbmYAAAAUdm1oZAAAAAAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAVdzdGJsAAAAp3N0c2QAAAAAAAAAAQAAAJdhdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAFAAOABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAAEmNvbHJuY2xjAAEAAQABAAAAL2F2Y0MBTUAz/+EAGGdNQDOadCk/LgIgAAADACAAAAMA0eMGVAEABGjuPIAAAAAYc3R0cwAAAAAAAAABAAAADgAAA+gAAAAUc3RzcwAAAAAAAAABAAAAAQAAABxzdHNjAAAAAAAAAAEAAAABAAAADgAAAAEAAABMc3RzegAAAAAAAAAAAAAADgAAAE8AAAAOAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA4AAAAOAAAAFHN0Y28AAAAAAAAAAQAAA7AAAAA0dXVpZFVTTVQh0k/Ou4hpXPrJx0AAAAAcTVREVAABABIAAAAKVcQAAAAAAAEAAAAAAAAAqHV1aWRVU01UIdJPzruIaVz6ycdAAAAAkE1URFQABAAMAAAAC1XEAAACHAAeAAAABBXHAAEAQQBWAFMAIABNAGUAZABpAGEAAAAqAAAAASoOAAEAZABlAHQAZQBjAHQAXwBhAHUAdABvAHAAbABhAHkAAAAyAAAAA1XEAAEAMgAwADAANQBtAGUALwAwADcALwAwADYAMAA2ACAAMwA6ADUAOgAwAAABA21kYXQAAAAYZ01AM5p0KT8uAiAAAAMAIAAAAwDR4wZUAAAABGjuPIAAAAAnZYiAIAAR//eBLT+oL1eA2Nlb/edvwWZflzEVLlhlXtJvSAEGRA3ZAAAACkGaAQCyJ/8AFBAAAAAJQZoCATP/AOmBAAAACUGaAwGz/wDpgAAAAAlBmgQCM/8A6YEAAAAJQZoFArP/AOmBAAAACUGaBgMz/wDpgQAAAAlBmgcDs/8A6YEAAAAJQZoIBDP/AOmAAAAACUGaCQSz/wDpgAAAAAlBmgoFM/8A6YEAAAAJQZoLBbP/AOmAAAAACkGaDAYyJ/8AFBAAAAAKQZoNBrIv/4cMeQ==';
  } catch (e) {
    callback(false);
    return;
  }

  elem.setAttribute('muted', 'muted');
  elem.setAttribute('autoplay', '');
  elem.setAttribute('playsinline', 'true');
  elem.setAttribute('webkit-plays-inline', 'true');
  elem.style.cssText = 'display:none';
  document.documentElement.appendChild(elem);
  // wait for the next tick to add the listener, otherwise the element may
  // not have time to play in high load situations (e.g. the test suite)
  setTimeout(function () {
    elem.addEventListener('playing', testAutoplay, false);
    timeout = setTimeout(testAutoplay, waitTime);
    try {
      elem.play();
    } catch (e) {}
  }, 0);
};

module.exports = isAutoplaySupported;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extendDefaults = __webpack_require__(17);

var _extendDefaults2 = _interopRequireDefault(_extendDefaults);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function moveit(opt) {

    jQuery(document).ready(function () {

        var that = this;

        var instances = [],
            elements,
            i = 0;

        this.options = {
            selector: ".moveit"
        };

        if ((typeof opt === "undefined" ? "undefined" : _typeof(opt)) === "object") {
            (0, _extendDefaults2.default)(this.options, opt);
        }

        elements = document.querySelectorAll(this.options.selector);

        for (i = 0; i < elements.length; i++) {
            if (getStyle(elements[i], 'display') != "none") {
                instances.push(new moveitItem(elements[i]));
                elements[i].style.opacity = 1;
            }
        }
    });
}

function getStyle(element, name) {
    return element.currentStyle ? element.currentStyle[name] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(name) : null;
}

function moveitItem(el) {

    this.el = el;

    this.style = window.getComputedStyle(el);
    this.speed = parseFloat(this.el.getAttribute("data-moveit-speed"));
    this.mode = this.el.getAttribute("data-moveit-mode");
    this.direction = this.el.getAttribute("data-moveit-direction");
    this.control = this.el.getAttribute("data-moveit-control");
    this.rect = el.getBoundingClientRect();
    this.scroller = window;

    if (!this.control) {
        this.control = "self";
    }

    if (!this.speed) {
        this.speed = 5;
    }

    if (!this.mode) {
        this.mode = "default";
    }

    if (!this.direction) {
        this.direction = "down";
    }

    this.window = {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        scrollX: getBodyScrollX(),
        scrollY: getBodyScrollY(),
        scrollCenterX: getBodyScrollX() + window.innerWidth / 2,
        scrollCenterY: getBodyScrollY() + window.innerHeight / 2
    };

    if (this.scroller == window) {
        this.scroller = this.window;
        this.scroller.el = window;
    } else {}
    // TODO: handle other scroller elements.


    /* Position of moveit element */

    this.position = {
        top: this.rect.top + this.window.scrollY,
        left: this.rect.left + this.window.scrollX,
        x: getPosition(this.el).x,
        y: getPosition(this.el).y,
        offsetHeight: this.el.offsetHeight,
        offsetWidth: this.el.offsetWidth,
        translateX: 0,
        translateY: 0
    };
    this.position.centerY = this.position.top + this.position.offsetHeight / 2;
    this.position.centerX = this.position.left + this.position.offsetWidth / 2;

    if (this.style.getPropertyValue("transform") != "none" && this.style.getPropertyValue("transform") != null) {
        var transformMatrix = this.style.getPropertyValue("transform").split(",");
        this.position.translateX = parseFloat(transformMatrix[4]);
        this.position.translateY = parseFloat(transformMatrix[5].slice(0, -1));
    }

    /* Position of control element (when this element is in the center of the screen, the moveit element should be in its normal position) */

    if (this.control == "parent" || this.control == "parentNode") {
        var controlEl = this.el.parentNode;
        var controlRect = controlEl.getBoundingClientRect();
        this.controlPosition = {
            top: controlRect.top + this.window.scrollY,
            left: controlRect.left + this.window.scrollX,
            x: getPosition(controlEl).x,
            y: getPosition(controlEl).y,
            offsetHeight: controlEl.offsetHeight,
            offsetWidth: controlEl.offsetWidth
        };
        this.controlPosition.centerY = this.controlPosition.top + this.controlPosition.offsetHeight / 2;
        this.controlPosition.centerX = this.controlPosition.left + this.controlPosition.offsetWidth / 2;
    } else {
        // control is element itself
        this.controlPosition = this.position;
    }

    var that = this;

    // console.log(this.window);
    // console.log('speed');
    // console.log(this.speed);
    // console.log('mode');
    // console.log(this.mode);
    // console.log('control');
    // console.log(this.control);
    // console.log('direction');
    // console.log(this.direction);
    // console.log('position');
    // console.log(this.position);
    // console.log('controlPosition');
    // console.log(this.controlPosition);

    this.scroller.el.addEventListener('scroll', function () {

        if (that.scroller.el == window) {
            that.scroller.scrollX = getBodyScrollX();
            that.scroller.scrollY = getBodyScrollY();
            that.scroller.scrollCenterX = getBodyScrollX() + window.innerWidth / 2;
            that.scroller.scrollCenterY = getBodyScrollY() + window.innerHeight / 2;
        } else {
            // TODO
        }

        that.update(that);
    });
}

moveitItem.prototype.update = function (that) {

    if (this.direction == "up") {
        this.down(true);
    } else if (this.direction == "down") {
        this.down(false);
    } else if (this.direction == "left") {
        this.right(true);
    } else if (this.direction == "right") {
        this.right(false);
    }
};

function getPosition(element) {
    var xPosition = 0;
    var yPosition = 0;

    while (element) {
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}

function getBodyScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function getBodyScrollX() {
    return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
}

function getElementScrollY(el) {
    return el.getBoundingClientRect().top + getBodyScrollY();
}

function getElementScrollX(el) {
    return el.getBoundingClientRect().left + getBodyScrollX();
}

moveitItem.prototype.down = function (reverse) {

    var item = this;

    var start = this.controlPosition.top - this.scroller.innerHeight / 2 * 3,
        end = this.controlPosition.top + this.controlPosition.offsetHeight + this.scroller.innerHeight / 2;

    if (this.scroller.scrollY > start && this.scroller.scrollY < end) {

        var scrollDiff = this.scroller.scrollCenterY - this.controlPosition.centerY;
        if (reverse) {
            // TODO check this
            scrollDiff = scrollDiff * -1;
        }
        var pos = -1 * scrollDiff / this.speed + this.position.translateY;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.position.translateX, pos, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, item.position.translateX, pos, 0);
                });
            }
        }
    }
};

moveitItem.prototype.right = function (reverse) {

    // TODO check this

    var item = this;

    var start = this.controlPosition.left - this.scroller.innerWidth / 2 * 3,
        end = this.controlPosition.left + this.controlPosition.offsetWidth + this.scroller.innerWidth / 2;

    if (this.scroller.scrollX > start && this.scroller.scrollX < end) {

        var scrollDiff = this.scroller.scrollCenterX - this.controlPosition.centerX;
        if (reverse) {
            // TODO check this
            scrollDiff = scrollDiff * -1;
        }
        var pos = -1 * scrollDiff / this.speed + this.position.translateX;

        if (scrollDiff < 0) {
            if (item.mode != "after-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.position.translateY, 0);
                });
            }
        } else {
            if (item.mode != "before-scroll") {
                window.requestAnimationFrame(function () {
                    item.applyStyles(item, pos, item.position.translateY, 0);
                });
            }
        }
    }
};

moveitItem.prototype.applyStyles = function (item, x, y, z) {
    (0, _lodash2.default)(function () {
        item.el.style.transform = "translate3d(" + x + "px, " + y + "px, " + z + "px)";
    }, 16)();
};

exports.default = moveit;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _debounce = __webpack_require__(6);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Table() {

    this.init();
}

Table.prototype.init = function (target_is_child, target_is_sibling) {

    var $this = this;

    var tables = document.querySelectorAll('table');

    if (tables !== null) {

        this.wrapAllTables(tables);

        var table_wrappers = document.querySelectorAll('.table__wrapper');

        if (table_wrappers !== null) {
            for (var i = 0; i < table_wrappers.length; i++) {

                var table_wrapper = table_wrappers[i];

                this.checkTableScroll(table_wrapper);
                table_wrapper.addEventListener('scroll', function () {
                    $this.checkTableScroll(table_wrapper);
                });

                var resizeFunction = (0, _debounce2.default)(function () {
                    $this.checkTableScroll(table_wrapper);
                }, 100);

                window.addEventListener('resize', resizeFunction, false);
            }
        }
    }
};

Table.prototype.wrapAllTables = function (tables) {
    for (var i = 0; i < tables.length; i++) {

        var table = tables[i];
        var wrapper = document.createElement('div');
        wrapper.classList.add('table__wrapper');
        wrapper.innerHTML = table.outerHTML;

        table.parentNode.insertBefore(wrapper, table);
        table.parentNode.removeChild(table);
    }
};

Table.prototype.checkTableScroll = function (table_wrapper) {
    if (table_wrapper.scrollWidth > table_wrapper.clientWidth + 1) {
        table_wrapper.classList.add('scrollable');
        if (table_wrapper.offsetWidth + table_wrapper.scrollLeft < table_wrapper.scrollWidth) {
            table_wrapper.classList.add('scrollRight');
        } else {
            table_wrapper.classList.remove('scrollRight');
        }
        if (table_wrapper.scrollLeft != 0) {
            table_wrapper.classList.add('scrollLeft');
        } else {
            table_wrapper.classList.remove('scrollLeft');
        }
    } else {
        table_wrapper.classList.remove('scrollable');
        table_wrapper.classList.remove('scrollLeft');
        table_wrapper.classList.remove('scrollRight');
    }
};

// Table.prototype.debounce = function(func, wait, immediate) {
//    var timeout;
//    return function() {
//        var context = this, args = arguments;
//        var later = function() {
//            timeout = null;
//            if (!immediate) func.apply(context, args);
//        };
//        var callNow = immediate && !timeout;
//        clearTimeout(timeout);
//        timeout = setTimeout(later, wait);
//        if (callNow) func.apply(context, args);
//    };
// };

exports.default = Table;

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.13.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-requestanimationframe-setclasses !*/
!function(e,n,t,r){function o(e,n){return typeof e===n}function i(e,n){return!!~(""+e).indexOf(n)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):_?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function a(){var e=t.body;return e||(e=s(_?"svg":"body"),e.fake=!0),e}function l(e,n,r,o){var i,l,f,u,p="modernizr",d=s("div"),c=a();if(parseInt(r,10))for(;r--;)f=s("div"),f.id=o?o[r]:p+(r+1),d.appendChild(f);return i=s("style"),i.type="text/css",i.id="s"+p,(c.fake?c:d).appendChild(i),c.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=p,c.fake&&(c.style.background="",c.style.overflow="hidden",u=S.style.overflow,S.style.overflow="hidden",S.appendChild(c)),l=n(d,e),c.fake&&c.parentNode?(c.parentNode.removeChild(c),S.style.overflow=u,S.offsetHeight):d.parentNode.removeChild(d),!!l}function f(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function u(e,t,r){var o;if("getComputedStyle"in n){o=getComputedStyle.call(n,e,t);var i=n.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&e.currentStyle&&e.currentStyle[r];return o}function p(e,t){var o=e.length;if("CSS"in n&&"supports"in n.CSS){for(;o--;)if(n.CSS.supports(f(e[o]),t))return!0;return!1}if("CSSSupportsRule"in n){for(var i=[];o--;)i.push("("+f(e[o])+":"+t+")");return i=i.join(" or "),l("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"===u(e,null,"position")})}return r}function d(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function c(e,n,t,a){function l(){u&&(delete N.style,delete N.modElem)}if(a=!o(a,"undefined")&&a,!o(t,"undefined")){var f=p(e,t);if(!o(f,"undefined"))return f}for(var u,c,m,v,y,h=["modernizr","tspan","samp"];!N.style&&h.length;)u=!0,N.modElem=s(h.shift()),N.style=N.modElem.style;for(m=e.length,c=0;c<m;c++)if(v=e[c],y=N.style[v],i(v,"-")&&(v=d(v)),N.style[v]!==r){if(a||o(t,"undefined"))return l(),"pfx"!==n||v;try{N.style[v]=t}catch(e){}if(N.style[v]!==y)return l(),"pfx"!==n||v}return l(),!1}function m(e,n){return function(){return e.apply(n,arguments)}}function v(e,n,t){var r;for(var i in e)if(e[i]in n)return!1===t?e[i]:(r=n[e[i]],o(r,"function")?m(r,t||n):r);return!1}function y(e,n,t,r,i){var s=e.charAt(0).toUpperCase()+e.slice(1),a=(e+" "+b.join(s+" ")+s).split(" ");return o(n,"string")||o(n,"undefined")?c(a,n,r,i):(a=(e+" "+P.join(s+" ")+s).split(" "),v(a,n,t))}function h(e,n,t){return y(e,r,r,n,t)}var g=[],C={_version:"3.13.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){g.push({name:e,fn:n,options:t})},addAsyncTest:function(e){g.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var w=[],S=t.documentElement,_="svg"===S.nodeName.toLowerCase(),x="Moz O ms Webkit",b=C._config.usePrefixes?x.split(" "):[];C._cssomPrefixes=b;var E={elem:s("modernizr")};Modernizr._q.push(function(){delete E.elem});var N={style:E.elem.style};Modernizr._q.unshift(function(){delete N.style});var P=C._config.usePrefixes?x.toLowerCase().split(" "):[];C._domPrefixes=P,C.testAllProps=y;var z=function(e){var t,o=prefixes.length,i=n.CSSRule;if(void 0===i)return r;if(!e)return!1;if(e=e.replace(/^@/,""),(t=e.replace(/-/g,"_").toUpperCase()+"_RULE")in i)return"@"+e;for(var s=0;s<o;s++){var a=prefixes[s];if(a.toUpperCase()+"_"+t in i)return"@-"+a.toLowerCase()+"-"+e}return!1};C.atRule=z;var T=C.prefixed=function(e,n,t){return 0===e.indexOf("@")?z(e):(-1!==e.indexOf("-")&&(e=d(e)),n?y(e,n,t):y(e,"pfx"))};Modernizr.addTest("requestanimationframe",!!T("requestAnimationFrame",n),{aliases:["raf"]}),C.testAllProps=h,Modernizr.addTest("cssanimations",h("animationName","a",!0)),function(){var e,n,t,r,i,s,a;for(var l in g)if(g.hasOwnProperty(l)){if(e=[],n=g[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(r=o(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],a=s.split("."),1===a.length?Modernizr[a[0]]=r:(Modernizr[a[0]]&&(!Modernizr[a[0]]||Modernizr[a[0]]instanceof Boolean)||(Modernizr[a[0]]=new Boolean(Modernizr[a[0]])),Modernizr[a[0]][a[1]]=r),w.push((r?"":"no-")+a.join("-"))}}(),function(e){var n=S.className,t=Modernizr._config.classPrefix||"";if(_&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(n+=" "+t+e.join(" "+t)),_?S.className.baseVal=n:S.className=n)}(w),delete C.addTest,delete C.addAsyncTest;for(var j=0;j<Modernizr._q.length;j++)Modernizr._q[j]();e.Modernizr=Modernizr}(window,window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
module.exports = __webpack_require__(20);


/***/ })
],[73]);


// WEBPACK FOOTER //
// js/main.js